import MenuIcon from '@mui/icons-material/Menu';
import {
  AppBar,
  Backdrop,
  Badge,
  Box,
  Button,
  CardMedia,
  Checkbox,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogProps,
  DialogTitle,
  Divider,
  Drawer,
  FormControlLabel,
  FormGroup,
  Grid,
  Hidden,
  IconButton,
  Input,
  InputAdornment,
  List,
  ListItemButton,
  ListItemText,
  Menu,
  MenuItem,
  MenuProps,
  Select,
  Stack,
  SxProps,
  Theme,
  Toolbar,
  Typography,
  useTheme,
} from '@mui/material';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import React, {
  Fragment,
  MutableRefObject,
  useEffect,
  useState,
  Dispatch,
  SetStateAction,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useRouteMatch } from 'react-router';
import { Link as RouterLink } from 'react-router-dom';
import { logout } from '../redux-store/actions/auth';
import {
  AIFActiveIcon,
  AIFIcon,
  AMCAdmins,
  ActiveAnalyticsIcon,
  AddNewIcon,
  ApplicationsIcon,
  BondsActiveIcon,
  BondsIcon,
  DashboardIcon,
  DashboardInactiveIcon,
  DirectEquityActiveIcon,
  DirectEquityIcon,
  DownloadIcon,
  InactiveAnalyticsIcon,
  MutualFundsIcon,
  NotificationsIcon,
  PMSActiveIcon,
  ManageFamilyIcon,
  PMSIcon,
  PaymentsActiveIcon,
  PaymentsInactiveIcon,
  ProductsIcon,
  ProfileIcon,
  ReportsIcon,
  // FundsSetup,
  RiskProfile,
  SearchIcon,
  SettingIcon,
  SidebarDashboardIcon,
  ViewEmailConsentIcon,
  ViewExistingIcon,
} from './customSVGs';
// import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { AccountCircle, ArrowDropDown, Close, MoreVert, Search } from '@mui/icons-material';
import CancelIcon from '@mui/icons-material/Cancel';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import { Formik, useFormikContext } from 'formik';
import { useHistory } from 'react-router';
import * as yup from 'yup';
import { MFTextField } from '../lib/formik';
import MFCheckbox from '../lib/formik/Checkbox';
import { SearchFieldWrapper, renderFilteredOptions } from '../lib/formik/searchSelectField';
import { getParams } from '../redux-store/actions/application';
import { RootStateType } from '../redux-store/reducers';
import { initialState } from '../redux-store/reducers/queryParams';
import { Applicant } from '../redux-store/types/api-types';
import { APPLICATION_TYPE, BONDS_LINK, ENABLE_Email_Consent, ENABLE_ORDER_MANAGEMENT, ENABLE_PAYMENT_CHECKER, OTPDisclaimer, ROLE_TYPE, USER_ROLES } from '../utils/constant';
import { copyGraphToClipboard, getCountryCodes, isFamilyView } from '../utils/utilityFunctions';
import { Item, ItemDetails } from './ApplicationDetails';
import { KeyValue } from './ApplicationDetails/personalDetails';
import { SubHeading } from './investors/components';
import { useSnackbar } from 'notistack';
import { setValue } from '../redux-store/actions/valueConverter';
import { SET_VALUE } from '../redux-store/types/valueConverter';
import DropdownIcon from '../assets/icons/DropdownIcon';
import { BlueEditIcon, BlueNavigationEditIcon, CartIcon, ContactRMIcon, HamburgerCLIcon, InfoIconOutlined, InvestorActiveReportsIcon, InvestorMFActiveIcon, InvestorOnBoardingIcon, InvestorReportsIcon, RecommendationsIcon, WarningIcon } from '../assets/SvgIcons';
import { setCartItemsCount } from '../redux-store/actions/cart';
import { setAppliedRecommendationsFilters, setRecommendationsActiveCategories } from '../redux-store/actions/investorProfile';
import dayjs from 'dayjs';
import { BottomDisclaimer } from './ApplicationDetails/TermsAndConditions';

import { FilePond, registerPlugin } from 'react-filepond';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size';
import { storeFamilyMemberId } from '../redux-store/actions/id';
import { clearSelectedPortfolioObj, setPortfolioHeldawayStatus, storePortfolioList, storeSelectedPortfolio, storeSelectedPortfolioObj } from '../redux-store/actions/portfolioFilter';


export function OtpTimer({ onResend }: { onResend: () => void }): JSX.Element {
  const [counter, setCounter] = useState(60);

  // Third Attempts
  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const timer: any = counter > 0 && setInterval(() => setCounter(counter - 1), 1000);
    return () => clearInterval(timer);
  }, [counter]);

  const handleResend = async () => {
    try {
      if (counter === 0) {
        await onResend();
        setCounter(60);
      }
    } catch (e) {
      console.error((e as Error).message);
    }
  };

  return (
    <Grid container justifyContent="space-between">
      <Grid item xs={12} md={8}>
        <Typography variant='body_400' color="text.secondary" component="span">
          {"Didn't receive OTP? "}
          <Button
            variant="text"
            sx={(theme: Theme) => ({
              cursor: counter > 0 ? "not-allowed" : "pointer",
              color: counter > 0 ? theme.palette.text.secondary : theme.palette.primary[500],
              padding: "0px 5px",
              minWidth: "unset",
              textTransform: "none",
              ...theme.typography.body_400
            })}
            onClick={handleResend}
            disabled={counter > 0}
            aria-label={counter > 0 ? `Resend OTP available in ${counter} seconds` : 'Resend OTP'}
          >
            Resend OTP
          </Button>
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        {counter > 0 && <Typography variant='body_400' color="text.secondary" aria-live="polite">in {counter} seconds</Typography>}
      </Grid>
    </Grid >
  );
}

// Footer
export const Footer = (): JSX.Element => {
  return (
    <Box
      component="footer"
      sx={{
        bgcolor: 'primary.main',
        display: 'flex',
        justifyContent: 'center',
        py: 1,
      }}>
      <Typography sx={{ color: 'common.white', width: 'unset', mr: '0.5rem' }}>
        Powered By{' '}
      </Typography>
      <CardMedia
        component="img"
        src="/images/kfin-new-logo.png"
        alt="kFintech Logo"
        sx={{ width: 'unset' }}
      />
    </Box>
  );
};
// Footer End

// Login Layout
export const LoginLayout = ({
  LoginText,
  children,
}: {
  LoginText: string;
  children: JSX.Element;
}): JSX.Element => {
  const history = useHistory();
  const theme = useTheme();
  return (
    <>
      <Hidden only={'xs'}>
        <Stack
          component="main"
          id="main-content"
          role="main"
          aria-label={LoginText}
          sx={{
            minHeight: '100vh',
            background: ' url("/images/thrive-bg.png")',
            backgroundSize: "cover",
            display: 'flex',
            flexDirection: 'column',
          }}>
          {/* <AppBar elevation={0} position="static" sx={{ bgcolor: 'transparent' }}>
        <Box
          sx={{
            flex: 1,
            display: 'flex',
            justifyContent: { xs: 'center', md: 'flex-start' },
            alignItems: 'center',
            px: { xs: '40%', sm: '15%', md: '16%' },
          }}
        >
          <CardMedia
            component="img"
            onClick={() => history.push('/')}
            src="/images/northern-arc-white-bg.svg"
            alt="Thriveiti - Go to home"
            sx={{
              margin: "30px 0px 0px 25px",
              cursor: 'pointer',
              width: '10rem',
              objectFit: 'contain',
            }}
          />
        </Box>
      </AppBar> */}
          {/* <Box
        sx={{
          flex: 1,
          display: 'flex',
          justifyContent: { xs: 'center', md: 'flex-start' },
          alignItems: 'center',
          px: { xs: 0, md: '10%' },
        }}
      >
        <Box
          sx={{
            bgcolor: 'grey.50',
            width: 'clamp(300px, 70%, 400px)',
            px: { xs: '25px', sm: '45px' },
            py: '50px',
            mb: 2,
            borderRadius: '10px',
            boxShadow: '0px 3.29214px 6.58427px rgba(27, 27, 27, 0.16)',
          }}
        >
          <Typography
            component="h1"
            variant="h1"
            sx={{
              color: 'primary.main',
              mb: '20px',
              textAlign: 'center',
              lineHeight: 1.2,
            }}
          >
            {LoginText}
          </Typography>
          {children}
        </Box>
      </Box> */}


          {/* <Box component={'footer'} sx={{ backgroundColor: theme.palette.grey[200] }}>
        <Disclaimer
          text={OTPDisclaimer}
          containerStyles={{
            // border: `1px solid ${theme.palette.grey[100]}`,
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: theme.palette.grey[200],
            width: '100%',
          }}
        />
      </Box> */}
          {/* <Footer /> */}

          <Box sx={{ flex: 1 }}>
            <Box sx={{
              flex: 1,
              display: 'flex',
              justifyContent: { xs: 'center', md: 'center' },
              alignItems: 'center',
              px: { xs: 0, sm: '10%', md: '15%', },
              mb: 5
            }}>
              <CardMedia
                component="img"
                onClick={() => history.push('/')}
                src="/images/thrive_logo.png"
                alt="Thriveiti - Go to home"
                sx={{
                  margin: "50px 0px 0px 0px",
                  cursor: 'pointer',
                  width: '20rem',
                  objectFit: 'contain',
                }}
              />
            </Box>
            <Box
              sx={{
                flex: 1,
                display: 'flex',
                justifyContent: { xs: 'center', md: 'center' },
                alignItems: 'center',
                px: { xs: 0, md: '10%' },
              }}
            >
              <Box
                sx={{
                  bgcolor: 'grey.50',
                  width: 'clamp(300px, 70%, 400px)',
                  px: { xs: '25px', sm: '35px' },
                  py: '50px',
                  mb: 2,
                  borderRadius: '20px',
                  boxShadow: '0px 3.29214px 6.58427px rgba(27, 27, 27, 0.16)',
                }}
              >
                <Typography
                  component="h1"
                  variant="h1"
                  sx={{
                    color: 'primary.main',
                    mb: '20px',
                    textAlign: 'center',
                    lineHeight: 1.2,
                  }}
                >
                  {LoginText}
                </Typography>
                {children}
              </Box>
            </Box>
          </Box>
        </Stack>
      </Hidden>
      <Hidden smUp>
        <Stack
          sx={{
            minHeight: '100vh',
            background: ' url("/images/thrive-bg.png")',
            backgroundSize: "cover",
            display: 'flex',
            flexDirection: 'column',
          }}>

          <Box sx={{ flex: 1 }}>
            <Box sx={{
              flex: 1,
              display: 'flex',
              justifyContent: { xs: 'center', md: 'flex-start' },
              alignItems: 'center',
              px: { xs: 0, sm: '10%', md: '15%', },
              mb: 1
            }}>
              <CardMedia
                component="img"
                onClick={() => history.push('/')}
                src="/images/thrive_logo.png"
                alt="Thriveiti - Go to home"
                sx={{
                  margin: "23px 23px 0px 20px",
                  cursor: 'pointer',
                  width: '15rem',
                  objectFit: 'contain',
                }}
              />
            </Box>
            <Box
              sx={{
                flex: 1,
                display: 'flex',
                justifyContent: { xs: 'center', md: 'flex-start' },
                alignItems: 'center',
                px: { xs: 0, md: '10%' },
              }}
            >
              <Box
                sx={{
                  bgcolor: 'grey.50',
                  width: 'clamp(300px, 70%, 400px)',
                  px: { xs: '15px', sm: '45px' },
                  py: { xs: '10px', sm: '20px' },
                  mb: 2,
                  borderRadius: '10px',
                  boxShadow: '0px 3.29214px 6.58427px rgba(27, 27, 27, 0.16)',
                }}
              >
                <Typography
                  variant="h2"
                  sx={{
                    color: 'primary.main',
                    mb: '10px',
                    textAlign: 'center',
                    lineHeight: 1.2,
                  }}
                >
                  {LoginText}
                </Typography>
                {children}
              </Box>
            </Box>
          </Box>
          <Box
            component="footer"
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            }}>
          </Box>
        </Stack>
      </Hidden>
    </>
  );
};
// Login Layout End

// Header & Sidenav
const drawerWidth = '16.87rem';

const MenuButton = ({
  isActive = false,
  to = null,
  text,
  onClick,
}: {
  isActive?: boolean;
  to?: string | null;
  text?: string;
  children?: JSX.Element;
  downArrow?: boolean;
  onClick?: () => void;
}) => {
  const disabled = to === null;
  return (
    <ListItemButton
      onClick={onClick}
      component={disabled ? Typography : RouterLink}
      to={to || ''}
      aria-current={isActive ? 'page' : undefined}
      aria-label={text}
      sx={{
        p: { xs: '10px 20px', md: '12px 15px' },
        background: isActive ? 'rgba(30, 144, 255, 1)' : 'transparent',
        color: isActive ? 'rgba(237, 242, 247, 1)' : 'secondary.main',
        stroke: isActive ? '#2057A6' : '#131836',
        strokeWidth: 0,
        height: '54px',
        '.MuiSvgIcon-root ': {
          opacity: isActive ? 1 : 0.5,
        },
        // ':hover': {
        //   background: isActive
        //     ? '#E9F4FF'
        //     : 'transparent',
        //   color: isActive
        //     ? 'text.primary'
        //     : 'transparent',
        // },
        textAlign: 'center',
        borderRadius: '15px',
      }}>
      {/* {children} */}
      {/* <ListItemText sx={{ color: 'text.primary', fontWeight: '800', fontFamily: 'Bai Jamjuree,sans-serif' }} primary={text} /> */}
      <Typography
        sx={{ color: isActive ? 'rgba(237, 242, 247, 1)' : 'text.primary', fontWeight: '600' }}
        variant="subtitle_400">
        {text}
      </Typography>
      {/* <ListItemText primary={text} />
      {downArrow && <ExpandMoreIcon />} */}
    </ListItemButton>
  );
};

const dashboardLinks = [
  { label: 'Home', link: '/dashboard' },
  { label: 'Clients', link: '/investors' },
  { label: 'Net Sales', link: '/net-sales' },
  { label: 'Total RMs', link: '/total-rm-detail' },
];

const productsLinks = [
  { label: 'Mutual Funds', link: '/product', disabled: false },
  { label: 'Debt & Bonds', link: `/product/debt`, disabled: false },
  { label: 'PMS', link: '/product/pms', disabled: false },
  { label: 'Alternates', link: '/product/alternates', disabled: false },
  { label: 'Direct Equity', link: '/product/direct-equity', disabled: true },
  // { label: 'Debt', link: '/product/debt', disabled: true },
  // { label: 'Bonds', link: `${BONDS_LINK}`, disabled: false },
  // { label: 'Alternates', link: '/product/alternates', disabled: true },
];

const analyticsLinks = [
  // { label: 'Mutual Fund Research', link: '/analytics/mutual-fund-research' },
  { label: 'Portfolio Analytics', link: '/analytics/portfolio-analytics' },
  // { label: 'Revenue Analytics', link: '/analytics/revenue-analytics' },
];

const applicationLinks = [
  { label: 'Add New', link: '/onboarding' },
  { label: 'View Existing', link: '/applications' },
  { label: 'View Email Consent', link: '/view-consent-email-list' },
  // { label: 'Onboarding DashBoard', link: '/onboard-overview' },

]


const bankLinks = [
  { label: 'Add/Update Bank', link: '/bank/updateBank' },
  { label: 'View Bank Status', link: '/bank/viewBank' },
]

const nomineeLinks = [
  { label: 'Add/Update Details', link: '/nominee/updateNominee' }
]

const familyLinks = [
  { label: 'View Families', link: '/family/ViewFamily' }
]


const ordersLinks = [
  { label: 'Order Dashboard', link: '/orders/order-dashboard' },
  { label: 'Order Entry', link: '/orders/order-entry' }
]

const KfinDrawer = ({ onToggleClick }: { onToggleClick: () => void }) => {
  const theme = useTheme();
  const history = useHistory();
  const dispatch = useDispatch();
  const [open, setOpen] = useState<'' | 'products' | 'dashboard' | 'applications' | 'banks' | 'reports' | 'analytics' | 'orders' | 'nominee' | 'family'>('');
  const {
    role = '',
    adminSupport,
    userDetails,
    subRole = ""
  } = useSelector((store: RootStateType) => store.auth);
  const rmName = userDetails?.RM_Name || 'User';
  const { path } = useRouteMatch();
  const dashboardMatch = [
    '/dashboard',
    '/investors',
    '/net-sales',
    '/total-rm-detail',
    '/gross-sales',
    '/book-size-detail',
  ].includes(path);
  const productsMatch = path.includes('/product');
  const reportsSectionMatch = path.includes('/reports-download');
  const applicationMatch = [
    '/onboarding',
    '/applications',
    '/application',
    '/application-details/:id',
    '/non-individual-application-details/:id',
    '/non-individual-application',
    '/application-preview/:id',
    '/non-individual-application-preview/:id',
  ].includes(path);
  const [menuAnchorEl, setMenuAnchorEl] = React.useState<null | HTMLElement>(null);
  const openMenu = Boolean(menuAnchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setMenuAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setMenuAnchorEl(null);
  };

  const handleProductsNavigation = (ele: any) => {
    // if (ele.label?.toLowerCase() === "bonds") {
    //   onToggleClick();
    //   window.open(ele.link, '_blank');
    //   return;
    // }
    history.push(ele.link);
    setOpen('');
    onToggleClick();
  }

  const handleAnalyticsNavigation = (ele: any) => {
    // history.push(ele.link);
    window.open(ele.link, '_blank');
    setOpen('');
    onToggleClick();
  }

  const handleApplicationsNavigation = (ele: any) => {
    history.push(ele.link);
    setOpen('');
    onToggleClick();
  }

  const handleBanksNavigation = (ele: any) => {
    history.push(ele.link);
    setOpen('');
    onToggleClick();
  }

  const handleNomineeNavigation = (ele: any) => {
    history.push(ele.link);
    setOpen('');
    onToggleClick();
  }

  const handleFamiliesNavigation = (ele: any) => {
    history.push(ele.link);
    setOpen('');
    onToggleClick();
  }

  const handleReportsNavigation = (type: string) => {
    dispatch(getParams(initialState))

    if ([USER_ROLES.AMC_ADMIN, USER_ROLES.OPE].includes(role) && type === "onboardingReports") {
      history.push('/reports');

      setOpen('');
      onToggleClick();
      return
    }

    if ([USER_ROLES.RM, USER_ROLES.OPE].includes(role)) {
      if (type === "transactionReports") {
        history.push('/reports-download');

        setOpen('');
        onToggleClick();
        return
      }
      if (
        type === "onboardingReports" &&
        ['RWM', 'RTL'].includes(ROLE_TYPE[`${subRole ?? ""}`.toUpperCase() as keyof typeof ROLE_TYPE])
      ) {
        history.push('/reports');

        setOpen('');
        onToggleClick();
        return
      }
    }
  }

  const handleOrdersNavigation = (ele: any) => {
    history.push(ele.link);
    setOpen('');
    onToggleClick();
  }

  const modifiedApplicationLinks = [USER_ROLES.AMC_ADMIN].includes(role) ?
    // applicationLinks.filter(obj => obj?.link !== '/onboard-overview') :
    applicationLinks.filter(obj => !['/onboard-overview', '/onboarding'].includes(obj?.link)) :
    applicationLinks

  return (
    <Box>
      <>
        <CardMedia
          component="img"
          src="/images/thriveiti_logo.png"
          onClick={() => history.push('/')}
          alt="Thriveiti - Go to home"
          sx={{
            // width:"15rem",
            width: '10rem',
            cursor: 'pointer',
            objectFit: 'contain',
            display: { xs: 'block' },
            margin: "25px 15px 30px 50px"
          }}
        />
        <List
          component="ul"
          sx={{

            ml: '1.5rem',
            mr: '1.5rem',
            '& .MuiListItemButton-root': {
              // mb: 1,
              flexDirection: { xs: 'row', md: 'row' },
              '& .MuiListItemText-root': { mx: { xs: 1, md: 0 } },
              '& .MuiListItemText-root span': {
                fontFamily: `${theme.typography.fontFamily}`,
                // fontSize: 16,
                // fontWeight: 500,
              },
            },
            '& .MuiIconButton-root': {
              padding: '0px'
            },
            display: 'flex',
            flexDirection: 'column',
            gap: '35px',
          }}>
          {/* <Box sx={{ display: { xs: 'flex', md: 'none' }, justifyContent: 'flex-end' }}>
            <IconButton
              onClick={onToggleClick}
              aria-label="close drawer"
              sx={{ color: 'text.secondary' }}>
              <CancelIcon />
            </IconButton>
          </Box> */}
          {[USER_ROLES.RM, USER_ROLES.OPE, USER_ROLES.DISTRIBUTOR, USER_ROLES.SUBDISTRIBUTOR].includes(role) && (
            <>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  rowGap: "15px"
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    // height: '54px',

                  }}
                >
                  <Box
                    role="button"
                    tabIndex={0}
                    sx={(theme: Theme) => ({
                      display: 'flex', justifyContent: 'flex-start', alignItems: 'center', width: '100%', padding: '12px 15px', borderRadius: '15px', columnGap: '15px', backgroundColor: path.includes('dashboard') ? theme.palette.primary[500] : theme.palette.common.white, cursor: 'pointer',
                      '&:hover': {
                        backgroundColor: path.includes('dashboard') ? '' : theme.palette.grey[100],
                      },
                      '&:focus-visible': {
                        outline: 'none !important',
                        boxShadow: path.includes('dashboard')
                          ? '0 0 0 2px #ffffff, 0 0 0 4px #0a6b74'
                          : `0 0 0 2px #0a6b74`,
                      }
                    })}
                    onClick={() => {
                      history.push('/dashboard');
                      onToggleClick();
                    }}
                    onKeyDown={(e: React.KeyboardEvent) => {
                      if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        history.push('/dashboard');
                        onToggleClick();
                      }
                    }}
                    aria-label="Dashboard"
                    aria-current={path.includes('dashboard') ? 'page' : undefined}
                  >
                    {path.includes('dashboard') ? <SidebarDashboardIcon /> : <DashboardInactiveIcon />}
                    <Typography variant='body_500' sx={{ color: path.includes('dashboard') ? theme.palette.common.white : 'text.secondary', cursor: 'pointer' }}>Dashboard</Typography>
                  </Box>
                  {/* <MenuButton
                  isActive={dashboardMatch}
                  text="Dashboard"
                  downArrow={open !== 'dashboard'}>
                  <DashboardIcon />
                </MenuButton> */}
                  {/* {open === "dashboard" ? <IconButton
                  onClick={() => setOpen('')}>
                  <ExpandLessIcon sx={{ color: 'text.primary' }} />
                </IconButton>
                  : <IconButton
                    onClick={() => setOpen('dashboard')}
                    tabIndex={-1}>
                    <ExpandMoreIcon sx={{ color: 'text.primary' }} />
                  </IconButton>} */}
                </Box>
                {/* <MenuButton
                  isActive={dashboardMatch}
                  text="Dashboard"
                  downArrow={open !== 'dashboard'}>
                  <DashboardIcon />
                </MenuButton> */}
                {/* {open === "dashboard" ? <IconButton
                  onClick={() => setOpen('')}>
                  <ExpandLessIcon sx={{ color: 'text.primary' }} />
                </IconButton>
                  : <IconButton
                    onClick={() => setOpen('dashboard')}
                    tabIndex={-1}>
                    <ExpandMoreIcon sx={{ color: 'text.primary' }} />
                  </IconButton>} */}
                {/* </Box> */}
              </Box>
              {/* {open === 'dashboard' && (
                <Box
                  sx={{
                    textAlign: 'center',
                    '.MuiTypography-root': {
                      my: 1,
                      py: 1,
                      fontWeight: 500,
                      fontSize: 14,
                      display: 'block',
                      textDecoration: 'none',
                      color: 'text.primary',
                      background: '#FFF',
                    },
                  }}>
                  {dashboardLinks.map((ele, index) => (
                    <Typography
                      sx={{ color: 'text.secondary' }}
                      variant="subtitle_500"
                      key={index}
                      component={RouterLink}
                      to={ele.link}>
                      {ele.label}
                    </Typography>
                  ))}
                </Box>
              )} */}

              <Box sx={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
                <Box
                  role="button"
                  tabIndex={0}
                  aria-expanded={open === 'products'}
                  aria-label="Products section"
                  sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}
                  onClick={() => setOpen(open === 'products' ? '' : 'products')}
                  onKeyDown={(e: React.KeyboardEvent) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault();
                      setOpen(open === 'products' ? '' : 'products');
                    }
                  }}>
                  <Typography variant="body_500" sx={{ fontWeight: '600', color: 'text.primary' }}>
                    PRODUCTS
                  </Typography>

                  {/* <MenuButton
                  isActive={productsMatch}
                // text="OK"
                // downArrow={open !== 'products'}
                // onClick={() => setOpen(open && open === 'products' ? '' : 'products')}
                >
                  <ProductsIcon />
                </MenuButton> */}
                  {open === 'products' ? <IconButton
                    onClick={() => setOpen('')}
                    aria-label="Collapse products menu"
                    tabIndex={-1}>
                    <ExpandLessIcon sx={{ color: 'text.primary' }} />
                  </IconButton> : <IconButton
                    onClick={() => setOpen('products')}
                    aria-label="Expand products menu"
                    tabIndex={-1}>
                    <ExpandMoreIcon sx={{ color: 'text.primary' }} />
                  </IconButton>}
                </Box>

                {open === 'products' && (
                  <Box
                    sx={{
                      textAlign: 'center',
                      padding: '12px 15px',
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '4px',
                      '.MuiTypography-root': {
                        // my: 1,
                        // py: 1,
                        // padding: '12px 15px',


                        // fontSize: '16px',
                        display: 'block',
                        textDecoration: 'none',
                        color: 'text.secondary',

                      },
                    }}>
                    {productsLinks.map((ele, index) => (
                      <Box
                        component={'button'}
                        key={index}
                        sx={{
                          display: "flex",
                          justifyContent: 'flex-start',
                          alignItems: 'center',
                          columnGap: '15px',
                          marginBottom: '12px',
                          cursor: 'pointer',
                          padding: '10px',
                          // '&:hover': {
                          //   backgroundColor: theme.palette.grey[100],
                          //   padding: '6px',
                          //   borderRadius: '10px'
                          // }
                          border: "none",
                          backgroundColor: theme.palette.common.white,
                          '&:hover': {
                            backgroundColor: theme.palette.grey[100],
                            padding: '10px',
                            borderRadius: '10px'
                          },
                          '&:disabled': {
                            backgroundColor: theme.palette.grey[50],
                            padding: '10px',
                            borderRadius: '10px',
                            cursor: "not-allowed"
                          }
                        }}
                        onClick={() => handleProductsNavigation(ele)}
                        disabled={ele.disabled}
                      >
                        {(index === 0 && <MutualFundsIcon />) ||
                          (index === 1 && <BondsIcon />) ||
                          (index === 2 && <PMSIcon />) ||
                          (index === 3 && <AIFIcon />) ||
                          (index === 4 && <DirectEquityIcon />)}
                        <Typography

                          key={index}
                          // component={RouterLink}
                          // to={ele.link}
                          style={{
                            padding: 0,
                            margin: 0,

                          }}
                          variant="subtitle_500">
                          {ele.label}
                        </Typography>
                      </Box>
                    ))}
                    {/* <IconButton onClick={() => setOpen('')}>
                    <ExpandLessIcon sx={{ color: 'primary.main' }} />
                  </IconButton> */}
                  </Box>
                )}
              </Box>
              {/* Family */}

              <Box sx={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
                <Box
                  role="button"
                  tabIndex={0}
                  aria-expanded={open === 'family'}
                  aria-label="Manage Family section"
                  sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}
                  onKeyDown={(e: React.KeyboardEvent) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault();
                      setOpen(open === 'family' ? '' : 'family');
                    }
                  }}
                  onClick={() => setOpen(open === 'family' ? '' : 'family')}
                >
                  <Typography variant="body_500" sx={{ fontWeight: '600', color: 'text.primary' }}>
                    MANAGE FAMILY
                  </Typography>
                  {open === 'family' ? <IconButton
                    onClick={() => setOpen('')}
                    aria-label="Collapse family menu">
                    <ExpandLessIcon sx={{ color: 'text.primary' }} />
                  </IconButton> : <IconButton
                    onClick={() => setOpen('family')}
                    aria-label="Expand family menu"
                    tabIndex={-1}>
                    <ExpandMoreIcon sx={{ color: 'text.primary' }} />
                  </IconButton>}
                </Box>

                {open === 'family' && (
                  <Box
                    sx={{
                      textAlign: 'center',
                      padding: '12px 15px',
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '4px',
                      '.MuiTypography-root': {
                        display: 'block',
                        textDecoration: 'none',
                        color: 'text.secondary',

                      },
                    }}>
                    {familyLinks.map((ele, index) => (
                      <Box
                        key={index}
                        sx={{
                          display: 'flex',
                          justifyContent: 'flex-start',
                          alignItems: 'center',
                          columnGap: '15px',
                          marginBottom: index == 1 ? 0 : '12px',
                          cursor: 'pointer',
                          padding: index === 1 ? "10px" : "6px",
                          '&:hover': {
                            backgroundColor: theme.palette.grey[100],
                            padding: index === 1 ? "10px" : "6px",
                            borderRadius: '10px'
                          }
                        }}
                        onClick={() => handleFamiliesNavigation(ele)}
                      >
                        <ManageFamilyIcon />
                        <Typography
                          variant="subtitle_500"
                          component={RouterLink}
                          to={ele.link}
                          sx={{ textAlign: 'left' }}
                          onClick={() => {
                            dispatch(getParams(initialState));
                          }}>
                          {ele.label}
                        </Typography>
                      </Box>
                    ))}
                  </Box>
                )}
              </Box>
            </>
          )}
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
            <Box
              role="button"
              tabIndex={0}
              aria-expanded={open === 'applications'}
              aria-label="Applications section"
              sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}
              onKeyDown={(e: React.KeyboardEvent) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  setOpen(open === 'applications' ? '' : 'applications');
                }
              }}
              onClick={() => setOpen(open === 'applications' ? '' : 'applications')}
            >
              <Typography variant="body_500" sx={{ fontWeight: '600', color: 'text.primary' }}>
                APPLICATIONS
              </Typography>
              {open === 'applications' ? <IconButton
                onClick={() => setOpen('')}
                aria-label="Collapse applications menu">
                <ExpandLessIcon sx={{ color: 'text.primary' }} />
              </IconButton> : <IconButton
                onClick={() => setOpen('applications')}
                aria-label="Expand applications menu"
                tabIndex={-1}>
                <ExpandMoreIcon sx={{ color: 'text.primary' }} />
              </IconButton>}
            </Box>

            {/* <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }}>
              <MenuButton
                isActive={applicationMatch}
                // text="APPLICATIONS"
                downArrow={open !== 'applications'}
              >
                <ApplicationsIcon />
              </MenuButton>

            </Box> */}
            {open === 'applications' && (
              <Box
                sx={{
                  textAlign: 'center',
                  padding: '12px 15px',
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '4px',
                  '.MuiTypography-root': {
                    // my: 1,
                    // py: 1,
                    // padding: '12px 15px',


                    // fontSize: '16px',
                    display: 'block',
                    textDecoration: 'none',
                    color: 'text.secondary',

                  },
                }}>
                {modifiedApplicationLinks.map((ele, index) => (
                  <Box
                    key={index}
                    sx={{
                      display: 'flex',
                      justifyContent: 'flex-start',
                      alignItems: 'center',
                      columnGap: '15px',
                      marginBottom: index == 3 ? 0 : '12px',
                      cursor: 'pointer',
                      padding: '6px',
                      '&:hover': {
                        backgroundColor: theme.palette.grey[100],
                        padding: '6px',
                        borderRadius: '10px'
                      }
                    }}
                    onClick={() => handleApplicationsNavigation(ele)}
                  >
                    {(index === 0 || index === 1 || index === 3) ? (
                      <>
                        {index === 0 && <AddNewIcon />}
                        {index === 1 && <ViewExistingIcon />}
                        {index === 3 && <InvestorOnBoardingIcon />}
                        <Typography
                          variant="subtitle_500"
                          component={RouterLink}
                          to={ele.link}
                          // sx={{ wordBreak: 'break-word' }}
                          sx={{ textAlign: 'left' }}
                          onClick={() => {
                            dispatch(getParams(initialState));
                          }}>
                          {ele.label}
                        </Typography>
                      </>
                    ) : (
                      <>
                        {ENABLE_Email_Consent && (
                          <>
                            <ViewEmailConsentIcon />
                            <Typography
                              // style={{ textWrap: 'nowrap', }}
                              sx={{ textAlign: 'left' }}
                              variant="subtitle_500"
                              component={RouterLink}
                              to={ele.link}

                              onClick={() => {
                                dispatch(getParams(initialState));
                              }}>
                              {ele.label}
                            </Typography>
                          </>
                        )}
                      </>
                    )}
                  </Box>
                ))}
              </Box>
            )}
          </Box>

          {/* Banks */}

          {(role === USER_ROLES.RM || role === USER_ROLES.OPE) && (
            <>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
                <Box
                  role="button"
                  tabIndex={0}
                  aria-expanded={open === 'banks'}
                  aria-label="Banks section"
                  sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}
                  onKeyDown={(e: React.KeyboardEvent) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault();
                      setOpen(open === 'banks' ? '' : 'banks');
                    }
                  }}
                  onClick={() => setOpen(open === 'banks' ? '' : 'banks')}
                >
                  <Typography variant="body_500" sx={{ fontWeight: '600', color: 'text.primary' }}>
                    BANKS
                  </Typography>
                  {open === 'banks' ? <IconButton
                    onClick={() => setOpen('')}
                    aria-label="Collapse banks menu">
                    <ExpandLessIcon sx={{ color: 'text.primary' }} />
                  </IconButton> : <IconButton
                    onClick={() => setOpen('banks')}
                    aria-label="Expand banks menu"
                    tabIndex={-1}>
                    <ExpandMoreIcon sx={{ color: 'text.primary' }} />
                  </IconButton>}
                </Box>

                {open === 'banks' && (
                  <Box
                    sx={{
                      textAlign: 'center',
                      padding: '12px 15px',
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '4px',
                      '.MuiTypography-root': {
                        display: 'block',
                        textDecoration: 'none',
                        color: 'text.secondary',

                      },
                    }}>
                    {bankLinks.map((ele, index) => (
                      <Box
                        key={index}
                        sx={{
                          display: 'flex',
                          justifyContent: 'flex-start',
                          alignItems: 'center',
                          columnGap: '15px',
                          marginBottom: index == 1 ? 0 : '12px',
                          cursor: 'pointer',
                          padding: index === 0 ? "10px" : "6px",
                          '&:hover': {
                            backgroundColor: theme.palette.grey[100],
                            padding: index === 0 ? "10px" : "6px",
                            borderRadius: '10px'
                          }
                        }}
                        onClick={() => handleBanksNavigation(ele)}
                      >
                        {index === 0 && <BlueNavigationEditIcon />}
                        {index === 1 && <ViewExistingIcon />}
                        <Typography
                          variant="subtitle_500"
                          component={RouterLink}
                          to={ele.link}
                          sx={{ textAlign: 'left' }}
                          onClick={() => {
                            dispatch(getParams(initialState));
                          }}>
                          {ele.label}
                        </Typography>
                      </Box>
                    ))}
                  </Box>
                )}
              </Box>

              {/* Nominee */}

              <Box sx={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
                <Box
                  role="button"
                  tabIndex={0}
                  aria-expanded={open === 'nominee'}
                  aria-label="Nominee section"
                  sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}
                  onKeyDown={(e: React.KeyboardEvent) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault();
                      setOpen(open === 'nominee' ? '' : 'nominee');
                    }
                  }}
                  onClick={() => setOpen(open === 'nominee' ? '' : 'nominee')}
                >
                  <Typography variant="body_500" sx={{ fontWeight: '600', color: 'text.primary' }}>
                    NOMINEE
                  </Typography>
                  {open === 'nominee' ? <IconButton
                    onClick={() => setOpen('')}
                    aria-label="Collapse nominee menu">
                    <ExpandLessIcon sx={{ color: 'text.primary' }} />
                  </IconButton> : <IconButton
                    onClick={() => setOpen('nominee')}
                    aria-label="Expand nominee menu"
                    tabIndex={-1}>
                    <ExpandMoreIcon sx={{ color: 'text.primary' }} />
                  </IconButton>}
                </Box>

                {open === 'nominee' && (
                  <Box
                    sx={{
                      textAlign: 'center',
                      padding: '12px 0px',
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '4px',
                      '.MuiTypography-root': {
                        display: 'block',
                        textDecoration: 'none',
                        color: 'text.secondary',

                      },
                    }}>
                    {nomineeLinks.map((ele, index) => (
                      <Box
                        key={index}
                        sx={{
                          display: 'flex',
                          justifyContent: 'flex-start',
                          alignItems: 'center',
                          columnGap: '15px',
                          marginBottom: index == 1 ? 0 : '12px',
                          cursor: 'pointer',
                          padding: index === 0 ? "10px" : "6px",
                          '&:hover': {
                            backgroundColor: theme.palette.grey[100],
                            padding: index === 0 ? "10px" : "6px",
                            borderRadius: '10px'
                          }
                        }}
                        onClick={() => handleNomineeNavigation(ele)}
                      >
                        {index === 0 && <BlueNavigationEditIcon />}
                        {index === 1 && <ViewExistingIcon />}
                        <Typography
                          variant="subtitle_500"
                          component={RouterLink}
                          to={ele.link}
                          sx={{ textAlign: 'left' }}
                          onClick={() => {
                            dispatch(getParams(initialState));
                          }}>
                          {ele.label}
                        </Typography>
                      </Box>
                    ))}
                  </Box>
                )}
              </Box>
            </>
          )}
          {/* Reports */}
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
            <Box
              role="button"
              tabIndex={0}
              aria-expanded={open === 'reports'}
              aria-label="Reports section"
              sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}
              onKeyDown={(e: React.KeyboardEvent) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  setOpen(open === 'reports' ? '' : 'reports');
                }
              }}
              onClick={() => setOpen(open === 'reports' ? '' : 'reports')}
            >
              <Typography variant="body_500" sx={{ fontWeight: '600', color: 'text.primary' }}>
                REPORTS
              </Typography>
              {open === 'reports' ? <IconButton
                onClick={() => setOpen('')}
                aria-label="Collapse reports menu">
                <ExpandLessIcon sx={{ color: 'text.primary' }} />
              </IconButton> : <IconButton
                onClick={() => setOpen('reports')}
                aria-label="Expand reports menu"
                tabIndex={-1}>
                <ExpandMoreIcon sx={{ color: 'text.primary' }} />
              </IconButton>}
            </Box>
            {open === 'reports' && (
              <>
                {[USER_ROLES.RM, USER_ROLES.OPE].includes(role) && (
                  <Box
                    sx={{
                      textAlign: 'center',
                      padding: '12px 15px',
                      '.MuiTypography-root': {
                        // fontSize: 16,
                        display: 'block',
                        textDecoration: 'none',
                        color: 'text.secondary',
                      },
                    }}>
                    <Box
                      component="button"
                      sx={(theme: Theme) => ({
                        display: 'flex',
                        justifyContent: 'flex-start',
                        alignItems: 'center',
                        columnGap: '15px',
                        cursor: 'pointer',
                        padding: '10px',
                        border: "none",
                        backgroundColor: "transparent",
                        width: "100%",
                        '&:hover': {
                          backgroundColor: theme.palette.grey[100],
                          padding: '10px',
                          borderRadius: '10px'
                        },
                        '&:disabled': {
                          backgroundColor: theme.palette.grey[50],
                          padding: '10px',
                          borderRadius: '10px',
                          cursor: "not-allowed"
                        }
                      })}
                      onClick={() => handleReportsNavigation("transactionReports")}
                    >
                      <Box sx={{ flexShrink: 0 }}>
                        <DownloadIcon />
                      </Box>
                      <Typography
                        variant="subtitle_500"
                        sx={{ lineHeight: "20px" }}
                      >
                        Transaction Reports
                      </Typography>
                    </Box>
                  </Box>
                )}
                {(
                  [USER_ROLES.AMC_ADMIN].includes(role) || [USER_ROLES.OPE].includes(role) ||
                  (
                    [USER_ROLES.RM, USER_ROLES.OPE].includes(role) &&
                    ['RWM', 'RTL'].includes(ROLE_TYPE[`${subRole ?? ""}`.toUpperCase() as keyof typeof ROLE_TYPE])
                  )
                ) && (
                    <Box
                      sx={{
                        textAlign: 'center',
                        padding: '12px 15px',
                        '.MuiTypography-root': {
                          // fontSize: 16,
                          display: 'block',
                          textDecoration: 'none',
                          color: 'text.secondary',
                        },
                      }}>
                      <Box
                        component="button"
                        sx={(theme: Theme) => ({
                          display: 'flex',
                          justifyContent: 'flex-start',
                          alignItems: 'center',
                          columnGap: '15px',
                          cursor: 'pointer',
                          padding: '10px',
                          border: "none",
                          backgroundColor: "transparent",
                          width: "100%",
                          '&:hover': {
                            backgroundColor: theme.palette.grey[100],
                            padding: '10px',
                            borderRadius: '10px'
                          },
                          '&:disabled': {
                            backgroundColor: theme.palette.grey[50],
                            padding: '10px',
                            borderRadius: '10px',
                            cursor: "not-allowed"
                          }
                        })}
                        onClick={() => handleReportsNavigation("onboardingReports")}
                      >
                        <Box sx={{ flexShrink: 0 }}>
                          <DownloadIcon />
                        </Box>
                        <Typography
                          variant="subtitle_500"
                          sx={{ lineHeight: "20px" }}
                        >
                          Onboarding Reports
                        </Typography>
                      </Box>
                    </Box>
                  )}
              </>
            )}
          </Box>

          {/* Analytics */}
          {[USER_ROLES.RM, USER_ROLES.OPE].includes(role) && (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
              <Box
                role="button"
                tabIndex={0}
                aria-expanded={open === 'analytics'}
                aria-label="Analytics section"
                sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}
                onKeyDown={(e: React.KeyboardEvent) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    setOpen(open === 'analytics' ? '' : 'analytics');
                  }
                }}
                onClick={() => setOpen(open === 'analytics' ? '' : 'analytics')}>
                <Typography variant="body_500" sx={{ fontWeight: '600', color: 'text.primary' }}>
                  ANALYTICS
                </Typography>

                {/* <MenuButton
              isActive={productsMatch}
            // text="OK"
            // downArrow={open !== 'products'}
            // onClick={() => setOpen(open && open === 'products' ? '' : 'products')}
            >
              <ProductsIcon />
            </MenuButton> */}
                {open === 'analytics' ? <IconButton
                  onClick={() => setOpen('')}
                  aria-label="Collapse analytics menu">
                  <ExpandLessIcon sx={{ color: 'text.primary' }} />
                </IconButton> : <IconButton
                  onClick={() => setOpen('analytics')}
                  aria-label="Expand analytics menu"
                  tabIndex={-1}>
                  <ExpandMoreIcon sx={{ color: 'text.primary' }} />
                </IconButton>}
              </Box>

              {open === 'analytics' && (
                <Box
                  sx={{
                    textAlign: 'center',
                    padding: '12px 15px',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '8px',
                    '.MuiTypography-root': {
                      // my: 1,
                      // py: 1,
                      // padding: '12px 15px',


                      // fontSize: '16px',
                      display: 'block',
                      textDecoration: 'none',
                      color: 'text.secondary',

                    },
                  }}>
                  {analyticsLinks.map((ele, index) => (
                    <Box
                      component="button"
                      key={index}
                      sx={{
                        display: 'flex',
                        justifyContent: 'flex-start',
                        alignItems: 'center',
                        columnGap: '15px',
                        marginBottom: '12px',
                        cursor: 'pointer',
                        padding: '10px',
                        border: "none",
                        backgroundColor: theme.palette.common.white,
                        '&:hover': {
                          backgroundColor: theme.palette.grey[100],
                          padding: '10px',
                          borderRadius: '10px'
                        },
                        '&:disabled': {
                          backgroundColor: theme.palette.grey[50],
                          padding: '10px',
                          borderRadius: '10px',
                          cursor: "not-allowed"
                        }
                      }}
                      onClick={() => handleAnalyticsNavigation(ele)}
                      disabled={ele.label === "Mutual Fund Research" || ele.label === "Revenue Analytics"}
                    >
                      {/* icons */}
                      {/* {(index === 0 && <MutualFundResearch />) ||
                        (index === 1 && <PortfolioAnalytics />) ||
                        (index === 2 && <RevenueAnalytics />)} */}
                      <Typography
                        // key={index}
                        // component={RouterLink}
                        // to={ele.link}
                        sx={{
                          padding: 0,
                          margin: 0,
                          fontFamily: `${theme.typography.fontFamily}`,
                        }}
                        variant="subtitle_500"
                      >
                        {ele.label}
                      </Typography>
                    </Box>
                  ))}
                  {/* <IconButton onClick={() => setOpen('')}>
                <ExpandLessIcon sx={{ color: 'primary.main' }} />
              </IconButton> */}
                </Box>
              )}
            </Box>
          )}


          {/* Order Management Start */}
          {(ENABLE_ORDER_MANAGEMENT && [USER_ROLES.RM, USER_ROLES.OPE].includes(role)) && (
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: '2px'
              }}
            >
              <Box
                role="button"
                tabIndex={0}
                aria-expanded={open === 'orders'}
                aria-label="Orders section"
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  cursor: 'pointer'
                }}
                onKeyDown={(e: React.KeyboardEvent) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    setOpen(open === 'orders' ? '' : 'orders');
                  }
                }}
                onClick={() => setOpen(open === 'orders' ? '' : 'orders')}
              >
                <Typography
                  variant="body_500"
                  sx={{
                    fontWeight: '600',
                    color: 'text.primary'
                  }}
                >
                  ORDERS
                </Typography>
                {open === 'orders' ? (
                  <IconButton aria-label="Collapse orders menu" onClick={() => setOpen('')}>
                    <ExpandLessIcon sx={{ color: 'text.primary' }} />
                  </IconButton>
                ) : (
                  <IconButton aria-label="Expand orders menu" onClick={() => setOpen('orders')}>
                    <ExpandMoreIcon sx={{ color: 'text.primary' }} />
                  </IconButton>
                )}
              </Box>
              {open === 'orders' && (
                <Box
                  sx={{
                    textAlign: 'center',
                    padding: '12px 15px',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '8px',
                    '.MuiTypography-root': {
                      display: 'block',
                      textDecoration: 'none',
                      color: 'text.secondary',
                      // fontSize: '16px',
                    },
                  }}>
                  {ordersLinks.map((ele, index) => (
                    <Box
                      component="button"
                      key={index}
                      sx={{
                        display: 'flex',
                        justifyContent: 'flex-start',
                        alignItems: 'center',
                        columnGap: '15px',
                        marginBottom: '12px',
                        cursor: 'pointer',
                        padding: '10px',
                        border: "none",
                        backgroundColor: theme.palette.common.white,
                        '&:hover': {
                          backgroundColor: theme.palette.grey[100],
                          padding: '10px',
                          borderRadius: '10px'
                        },
                        '&:disabled': {
                          backgroundColor: theme.palette.grey[50],
                          padding: '10px',
                          borderRadius: '10px',
                          cursor: "not-allowed"
                        }
                      }}
                      onClick={() => handleOrdersNavigation(ele)}
                    >
                      {ele.label === "Order Dashboard" && <ViewExistingIcon />}
                      {ele.label === "Order Entry" && <DashboardInactiveIcon />}
                      <Typography
                        sx={{
                          padding: 0,
                          margin: 0,
                          fontFamily: `${theme.typography.fontFamily}`,
                          textAlign: 'left'
                        }}
                        variant="subtitle_500"
                      >
                        {ele.label}
                      </Typography>
                    </Box>
                  ))}
                </Box>
              )}
            </Box>
          )}
          {/* Order Management End */}
          {USER_ROLES.AMC_ADMIN === role && (
            <>
              <MenuButton text="User Management" to="/user-management">
                <PersonOutlineOutlinedIcon />
              </MenuButton>
              {/* <MenuButton text="Funds Setup" to="/funds-setup">
              <FundsSetup />
            </MenuButton> */}
              {/* <MenuButton text="Reports" to="/reports">
              <Reports />
          </MenuButton>*/}
              {adminSupport && (
                <MenuButton text="Admin Support" to="/admin-support">
                  <RiskProfile />
                </MenuButton>
              )}
              {/* <MenuButton text="Risk Profile" to="/risk-profile">
              <RiskProfile />
            </MenuButton> */}
            </>
          )}
          {USER_ROLES.SUPER_ADMIN === role && (
            <MenuButton text="AMC Admins" to="/amc-admins">
              <AMCAdmins />
            </MenuButton>
          )}
          {/* <MenuButton to="" text="Settings">
          <SettingsIcon />
        </MenuButton> */}
          {/* <Box
            onClick={handleClick}
            sx={{
              my: 1,
              px: 2,
              py: 3,
              background:
                'linear-gradient(88.93deg, rgba(51, 127, 201, 0.1) 24.43%, rgba(51, 127, 201, 0) 93.37%)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-around',
              cursor: 'pointer',
            }}>
            <AccountCircle />
            <Box sx={{ display: 'flex', flexDirection: 'row' }}>

              <Typography
                sx={{
                  fontWeight: 500,
                  fontSize: 16,
                  textDecoration: 'none',
                  color: '#323232',
                }}>
                {rmName?.split(' ')[0]}
              </Typography>
              <MoreVert
                id="demo-positioned-button"
                aria-controls={openMenu ? 'demo-positioned-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={openMenu ? 'true' : undefined}
              />
            </Box>
          </Box>
          <Menu
            id="demo-positioned-menu"
            aria-labelledby="demo-positioned-button"
            anchorEl={menuAnchorEl}
            open={openMenu}
            onClose={handleClose}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'left',
            }}
            transformOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}>
            <MenuItem onClick={handleClose}>
              <Stack direction="row" gap={2}>
                <CardMedia
                  component="img"
                  src="/images/settings-blue.svg"
                  alt="settings"
                  sx={{ objectFit: 'contain' }}
                />
                <Typography sx={{ color: '#776D6D' }}>Settings</Typography>
              </Stack>
            </MenuItem>
            <Divider />
            <MenuItem onClick={() => dispatch(logout())}>
              <Stack direction="row" gap={2}>
                <CardMedia
                  component="img"
                  src="/images/logout-blue.svg"
                  alt="settings"
                  sx={{ objectFit: 'none' }}
                />
                <Typography sx={{ color: '#776D6D' }}>Logout</Typography>
              </Stack>
            </MenuItem>
          </Menu> */}
        </List>
      </>
    </Box >
  );
};

export const FilterDrawer = ({
  selectedFilters,
  setSelectedFilters,
  ...rest
}: MenuProps & {
  selectedFilters: {
    [key: string]: string[];
  };
  setSelectedFilters: React.Dispatch<React.SetStateAction<{ [key: string]: string[] }>>;
}): JSX.Element => {
  const [selectedFilterSection, setSelectedFilterSection] = useState<number | string>(-1);
  const [selectedLocalFilters, setSelectedLocalFilters] = useState<{ [key: string]: string[] }>(
    selectedFilters
  );
  const [search, setSearch] = useState<string>('');
  const { filters: totalFilters } = useSelector((state: RootStateType) => state.products);
  const filters = totalFilters
    .filter((each) => {
      const children = each.options.filter((option) => {
        return option && typeof option === 'object'
          ? option.label.toLowerCase().includes(search.toLowerCase())
          : option && option.toLowerCase().includes(search.toLowerCase());
      });
      return children.length > 0;
    })
    .map((each) => {
      return {
        ...each,
        options: each.options.filter((option) =>
          option && typeof option === 'object'
            ? option.label.toLowerCase().includes(search.toLowerCase())
            : option && option.toLowerCase().includes(search.toLowerCase())
        ),
      };
    });

  useEffect(() => {
    setSelectedLocalFilters(selectedFilters);
  }, [selectedFilters]);
  return (
    <Menu
      {...rest}
      transformOrigin={{ horizontal: 'center', vertical: 'top' }}
      PaperProps={{ sx: { maxWidth: '400px' } }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%', p: 2, gap: 4 }}>
        <Input
          placeholder="Search"
          fullWidth
          endAdornment={<Search />}
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          inputProps={{ 'aria-label': 'Search' }}
        />
        <IconButton onClick={(e) => rest?.onClose && rest?.onClose(e, 'backdropClick')} aria-label="Close search">
          <Close />
        </IconButton>
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, p: 2 }}>
        {filters.map(
          (
            {
              title,
              key,
              options,
            }: {
              title: string;
              key: string;
              options: ({ label: string; value: string } | string)[];
            },
            index: number
          ) => (
            <Box key={`${title}_${index}`} sx={{ width: '100%' }}>
              <Box>
                <Box
                  onClick={() => {
                    setSelectedFilterSection(selectedFilterSection === key ? -1 : key);
                  }}
                  sx={{
                    width: '100%',
                    gap: 3,
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    cursor: 'pointer',
                  }}>
                  <Typography>{title}</Typography>
                  <ArrowDropDown sx={{ color: '#337FC9' }} />
                </Box>
                <Divider />
              </Box>
              {selectedFilterSection === key && (
                <Box
                  sx={{
                    pt: 1,
                    px: 2,
                    maxHeight: '150px',
                    transition: '0.3s all',
                    overflow: 'auto',
                  }}>
                  <FormGroup>
                    {options.map(
                      (option: { label: string; value: string } | string, index: number) => {
                        let label = '',
                          value = '';
                        if (option && typeof option === 'object') {
                          label = option.label;
                          value = option.value;
                        } else if (option) {
                          label = option;
                          value = option;
                        }

                        return label && value ? (
                          <Fragment key={`${value}_${index}`}>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={
                                    selectedLocalFilters?.[key]
                                      ? selectedLocalFilters?.[key].includes(value)
                                      : false
                                  }
                                  onChange={(e) => {
                                    const updatedFilters = { ...selectedLocalFilters };
                                    const { checked } = e.target;
                                    if (updatedFilters[key]) {
                                      if (checked) {
                                        const values = [...updatedFilters[key]];
                                        if (!values.includes(value)) {
                                          values.push(value);
                                        }
                                        updatedFilters[key] = values;
                                      } else {
                                        updatedFilters[key] = updatedFilters[key].filter(
                                          (val) => val !== value
                                        );
                                      }
                                    } else if (checked) {
                                      updatedFilters[key] = [value];
                                    }
                                    setSelectedLocalFilters(updatedFilters);
                                  }}
                                  checkedIcon={
                                    <Box
                                      sx={{
                                        border: '2px solid #22242C',
                                        margin: '2px',
                                        borderRadius: '2px',
                                        backgroundColor: '#337FC9',
                                        '&:before': {
                                          display: 'block',
                                          width: 16,
                                          height: 16,
                                          content: '""',
                                        },
                                      }}></Box>
                                  }
                                />
                              }
                              label={label}
                            />
                            <Divider />
                          </Fragment>
                        ) : null;
                      }
                    )}
                  </FormGroup>
                </Box>
              )}
            </Box>
          )
        )}
        {/* {selectedFilterSection ? (
          <Stack
            direction="row"
            alignItems="center"
            sx={{ width: '80%', flexWrap: 'wrap', gap: 1 }}
            spacing={1}>
            {selectedLocalFilters?.[selectedFilterSection]?.map((each) => (
              <Box
                key={each}
                sx={{
                  background: '#D9D9D9',
                  p: '4px 6px',
                  borderRadius: '9px',
                  cursor: 'pointer',
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}>
                <Typography sx={{ color: '#323232', fontSize: '12px' }}>{each}</Typography>
                <Close
                  sx={{ color: '#6D6868', width: 16, ml: 1 }}
                  onClick={() => {
                    const updatedFilters = { ...selectedLocalFilters };
                    updatedFilters[selectedFilterSection] = updatedFilters?.[
                      selectedFilterSection
                    ].filter((val) => val !== each);
                    setSelectedLocalFilters(updatedFilters);
                  }}
                />
              </Box>
            ))}
          </Stack>
        ) : null} */}
        <Box sx={{ display: 'flex', flexDirection: 'row', gap: 3 }}>
          <Button
            onClick={(e) => {
              setSelectedFilters(selectedLocalFilters);
              rest?.onClose && rest?.onClose(e, 'backdropClick');
            }}
            sx={{
              bgcolor: '#337FC9',
              borderRadius: '5px',
              fontWeight: 'normal',
              padding: 0,
              px: 1,
              '&:hover': { bgcolor: '#2868a6' },
            }}>
            Apply
          </Button>
          <Button
            onClick={(e) => {
              setSelectedFilters({});
              rest?.onClose && rest?.onClose(e, 'backdropClick');
            }}
            sx={{
              border: '1px solid #337FC9',
              borderRadius: '5px',
              padding: 0,
              px: 1,
              color: '#337FC9',
              fontWeight: 'normal',
              '&:hover': {
                bgcolor: '#eaf0f5',
              },
            }}>
            Clear All
          </Button>
        </Box>
      </Box>
    </Menu>
  );
};

export const HeaderSidenav = ({
  mobileOpen,
  setMobileOpen,
  handleDrawerToggle,
  handleToggle
}: {
  mobileOpen: boolean;
  setMobileOpen: Dispatch<SetStateAction<boolean>>;
  handleDrawerToggle: () => void;
  handleToggle: () => void
}): JSX.Element => {
  const dispatch = useDispatch();
  // const history = useHistory();
  const location = useLocation();

  return (
    <>
      <Box
        component="nav"
        sx={(theme: Theme) => ({
          // width: { md: drawerWidth },
          // flexShrink: { md: 0 },
          [theme.breakpoints.down(1400)]: {
            display: "none"
          },
          [theme.breakpoints.up(1400)]: {
            width: drawerWidth,
            flexShrink: 0
          },
        })}
        aria-label="Sidebar navigation">
        {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          anchor="left"
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={(theme: Theme) => ({
            // display: { xs: 'block', md: 'none' },
            display: { xs: 'block' },
            [theme.breakpoints.up(1400)]: {
              display: "none"
            },
            '& .MuiDrawer-paper': {
              boxSizing: 'border-box',
              width: drawerWidth,
            },
          })}
        >
          <KfinDrawer onToggleClick={() => setMobileOpen(!mobileOpen)} />
        </Drawer>
        <Drawer
          variant="permanent"
          sx={(theme: Theme) => ({
            // display: { xs: 'none', md: 'block' },
            display: { xs: 'none' },
            [theme.breakpoints.up(1400)]: {
              display: "block"
            },
            '& .MuiDrawer-paper': {
              boxSizing: 'border-box',
              width: drawerWidth,
              // mt: '100px',
              border: 0,
              minHeight: '100vh',
              overflow: 'auto',
              // pb: 'calc(65px + 10%)',
              // justifyContent: 'center',
            },
            '& .MuiDrawer-paper::-webkit-scrollbar': {
              width: '5px', // Width of the scrollbar
            },
            '& .MuiDrawer-paper::-webkit-scrollbar-thumb': {
              backgroundColor: 'rgba(0, 0, 0, 0.5)', // Color of the scrollbar thumb
              borderRadius: '10px', // Rounded corners of the scrollbar thumb
            },
          })}
          open>
          <KfinDrawer onToggleClick={handleToggle} />
        </Drawer>
      </Box >
    </>
  );
};
// Header & Sidenav END

export const Header = ({ handleDrawerToggle }: { handleDrawerToggle: () => void }): JSX.Element => {
  const theme = useTheme();
  const { role } = useSelector((store: RootStateType) => store.auth);
  const { cartItemsCount = 0 } = useSelector((store: RootStateType) => store.cart);
  const { rmName = "", businessDate = "", company = "", environment = "", userRole = "" } = useSelector((store: RootStateType) => store.navbarInfo);
  const { investorClientId = "", clientInterfaceCode = "", viewAsFamilyId = "" } = useSelector((store: RootStateType) => store.id);

  const isViewingOtherFamilyMember = !!viewAsFamilyId
    && viewAsFamilyId !== investorClientId
    && viewAsFamilyId !== clientInterfaceCode;

  const formattedBusinessDate = businessDate ? dayjs(businessDate, 'DD/MM/YYYY').format('DD MMM, YYYY') : ""

  const dispatch = useDispatch();
  const [menuAnchorEl, setMenuAnchorEl] = useState<null | HTMLElement>(null);
  const [isLogout, setIsLogout] = useState<boolean>(false);
  const menuOpen = Boolean(menuAnchorEl);
  const { palette } = useTheme();

  const history = useHistory()

  const handleProfileLogout = async () => {
    // dispatch(setCartItemsCount(0));
    setIsLogout(true);
    await dispatch(logout());
    setIsLogout(false)
  }

  const handleCartIconClick = () => {
    if (location.pathname !== '/cart') {
      history.push("/cart")
    }
  }

  return (
    <>
      <Box
        component="header"
        aria-label="Site header"
        sx={(theme: Theme) => ({
          display: 'flex',
          // justifyContent: { xs: 'space-between', md: 'flex-end' },
          justifyContent: { xs: 'space-between' },
          alignItems: 'center',
          // padding: { xs: '25px 20px 20px', md: '20px 25px 0px 25px' },
          padding: { xs: '15px 20px 10px' },
          mb: { xs: '5px' },
          // backgroundColor: 'rgba(247, 247, 247, 1)',
          // backgroundColor: { xs: theme.palette.common.white, md: 'rgba(247, 247, 247, 1)' },
          backgroundColor: { xs: theme.palette.common.white },
          [theme.breakpoints.up(1400)]: {
            backgroundColor: theme.palette.background.default,
            justifyContent: 'flex-end',
            padding: '20px 25px 0px 25px'
          },
        })}>
        {/* <Box
          sx={{
            minWidth: '300px',
            borderRadius: '57px',
            height: '47.17px',
            border: '1px solid #6C737F',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
            padding: '16.25px 17.5px 16.25px 17px',
            cursor: 'pointer',
          }}>
          <SearchIcon />
          <Typography
            sx={{
              color: 'text.secondary',
              paddingLeft: '10px',
              paddingTop: '2px',
              paddingBottom: '2px',
            }}
            variant="subtitle_400">
            Search
          </Typography>
        </Box> */}
        <Box sx={{
          display: { xs: 'flex', },
          // display: { xs: 'flex', md: 'none' }, 
          [theme.breakpoints.up(1400)]: {
            display: "none"
          },
          alignItems: 'center',
          columnGap: '0.6rem',
        }}>
          <IconButton
            aria-label="Open navigation menu"
            edge="start"
            onClick={handleDrawerToggle}
            sx={(theme: Theme) => ({
              // display: { md: 'none' },
              [theme.breakpoints.up(1400)]: {
                display: "none"
              },
              color: 'text.primary'
            })}>
            <HamburgerCLIcon />
          </IconButton>
          <CardMedia
            component="img"
            onClick={() => history.push("/")}
            src="/images/thriveiti_logo.png"
            alt="Thriveiti - Go to home"
            sx={{
              width: '9rem',
              cursor: 'pointer',
              objectFit: 'contain'
            }}
          />
        </Box>

        <Box
          sx={{
            display: { xs: "flex" },
            columnGap: "1.5rem"
          }}
        >
          {/* {isRMLikeRole(role)
            && (
              <>
                {(rmName || formattedBusinessDate || company) && (
                  <Box
                    sx={(theme: Theme) => ({
                      display: "flex",
                      columnGap: "1rem",
                      alignItems: "center",
                      boxShadow: `0px 4px 10px 0px ${theme.palette.common.black}0D`,
                      padding: '5px'
                    })}
                  >
                    {rmName && (
                      <Typography
                        variant='body_600'
                        sx={(theme: Theme) => ({ color: theme.palette.primary[500] })}
                      >
                        {`${rmName} (${userRole})`}
                      </Typography>

                    )}
                    {formattedBusinessDate && (
                      <Typography
                        variant='body_600'
                        sx={(theme: Theme) => ({ color: theme.palette.primary[500] })}
                      >
                        System Date: {formattedBusinessDate}
                      </Typography>
                    )}
                    {company && (
                      <Typography
                        variant='body_600'
                        sx={(theme: Theme) => ({ color: theme.palette.primary[500] })}
                      >
                        Company: {company}
                      </Typography>
                    )}

                    {environment && (
                      <Typography
                        variant='body_600'
                        sx={(theme: Theme) => ({ color: theme.palette.primary[500] })}
                      >
                        Environment: {environment}
                      </Typography>
                    )}
                  </Box>
                )}
              </>
            )} */}

          <Box sx={{
            display: { xs: 'flex' },
            alignItems: 'center',
          }}>
            {/* <Box
          sx={{
            minWidth: '50px',
            height: '50px',
            borderRadius: '57px',
            backgroundColor: 'rgba(108, 115, 127, 0.1)',
            marginRight: '10px',
            padding: '15px',
          }}>
          <NotificationsIcon />
        </Box>
        <Box
          sx={{
            minWidth: '50px',
            height: '50px',
            borderRadius: '57px',
            backgroundColor: 'rgba(108, 115, 127, 0.1)',
            marginRight: '10px',
            padding: '15px',
          }}>
          <SettingIcon />
        </Box> */}
            {/* <Box
          sx={{
            minWidth: '50px',
            height: '50px',
            borderRadius: '57px',
            backgroundColor: 'rgba(108, 115, 127, 0.1)',
            padding: '11px',
          }}>
          <ProfileIcon />
        </Box> */}
            {[USER_ROLES.INVESTOR].includes(role) && (
              <IconButton
                aria-label={`Shopping cart${cartItemsCount > 0 ? `, ${cartItemsCount} items` : ''}`}
                sx={{
                  padding: 0,
                  opacity: isViewingOtherFamilyMember ? 0.5 : 1,
                  cursor: isViewingOtherFamilyMember ? 'not-allowed' : 'pointer',
                  '&.Mui-disabled': {
                    pointerEvents: 'auto',
                    cursor: 'not-allowed',
                  },
                }}
                disabled={isViewingOtherFamilyMember}
                onClick={handleCartIconClick}
              >
                <Badge
                  invisible={cartItemsCount === 0}
                  badgeContent={cartItemsCount}
                  sx={(theme: Theme) => ({
                    '& .MuiBadge-badge': {
                      right: 5,
                      top: 10,
                      backgroundColor: theme.palette.primary[500],
                      color: theme.palette.common.white,
                      ...theme.typography.subtitle_600,
                      // borderRadius: '8px',
                      // height: '10px'

                    },
                  })}
                >
                  <CartIcon />
                </Badge>
              </IconButton>
            )}
            <IconButton
              aria-label="User profile menu"
              sx={{ padding: 0, ml: 2 }}
              onClick={(e) => setMenuAnchorEl(e.currentTarget)}
              aria-haspopup="true"
              aria-expanded={menuOpen ? 'true' : undefined}
            >
              <ProfileIcon />
            </IconButton>

          </Box>
        </Box>

      </Box >

      <Menu
        anchorEl={menuAnchorEl}
        open={menuOpen}
        onClose={() => setMenuAnchorEl(null)}
        MenuListProps={{
          'aria-labelledby': 'logout-button',
          sx: {
            padding: "8px 0px",

          }
        }}
        slotProps={{
          paper: {
            sx: {
              width: { xs: "100px", sm: "200px" },
              borderRadius: "12px",
              backgroundColor: palette.common.white,
            }
          }
        }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}

      >
        <MenuItem
          onClick={() => {
            handleProfileLogout()
          }}
          disabled={isLogout}
          sx={{
            [theme.breakpoints.down("sm")]: {
              fontSize: "13px",
              padding: "6px 12px",
              minHeight: "32px",
            },
          }}
        >
          {isLogout ? 'Logging out...' : 'Logout'}
        </MenuItem>
      </Menu >

    </>
  );
};

export const CommonLayout = ({ children }: { children: JSX.Element }): JSX.Element => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const handleToggle = () => {
    setMobileOpen(false);
  }
  return (
    <>
      <Box sx={{ display: 'flex', width: '100%' }}>
        <HeaderSidenav
          mobileOpen={mobileOpen}
          setMobileOpen={setMobileOpen}
          handleDrawerToggle={handleDrawerToggle}
          handleToggle={handleToggle}
        />
        <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', flexGrow: 1, minWidth: 0 }}>
          <Header handleDrawerToggle={handleDrawerToggle} />
          <Box
            component="main"
            id="main-content"
            tabIndex={-1}
            sx={(theme: Theme) => ({
              flex: 1,
              // mt: '7px',
              ml: { xs: 0, md: 0 },
              p: { xs: '0 10px 25px 15px', sm: '0 25px 25px 25px' },

              borderRadius: '50px 0 0 0',
              // bgcolor: { xs: '', md: 'rgba(247, 247, 247, 1)' },
              bgcolor: { xs: '', },
              // minHeight: '100vh',
              // overflow: 'auto',
              // overflowY:"hidden"
              [theme.breakpoints.up(1400)]: {
                bgcolor: theme.palette.background.default
              },
              '&:focus': {
                outline: 'none',
              },
            })}>
            {/* <Container maxWidth="lg" disableGutters={true}
              sx={(theme: Theme) => ({
                [theme.breakpoints.up('xl')]: {
                  maxWidth: '100%',
                }
              })}>
              {children}
            </Container> */}
            <Container maxWidth={false} disableGutters={true}>
              {children}
            </Container>
          </Box>
          <Box
            component="footer"
            sx={(theme: Theme) => ({
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              backgroundColor: theme.palette.common.white,
              padding: '10px',
            })}>
            <Disclaimer
              text={<BottomDisclaimer />}
              containerStyles={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-start',
                width: '100%',
              }}
            />
          </Box>
        </Box>
      </Box>
      {/* <Footer /> */}
    </>
  );
};

const InvestorLoginDrawer = ({ onToggleClick }: { onToggleClick: () => void }) => {
  const history = useHistory();
  const theme = useTheme();
  const dispatch = useDispatch();
  const [open, setOpen] = useState<'' | 'invest' | 'dashboard' | 'recommendations' | 'banks' | 'nominee' | 'others' | 'family'>('');
  const [openSub, setOpenSub] = useState<string>(''); // for nested dropdowns like analytics

  const { bseClientActivationStatus = "", isPortfolioAvailable, assetClassObj = {
    mutual_funds: false,
    debt: false,
    pms: false,
    alternates: false,
    direct_equity: false
  } } = useSelector((state: RootStateType) => state.id)
  const { loggedInSelectedPortfolio, loggedInSelectedPortfolioObj, loggedInPortfolioList, loggedInIsPortfolioHeldaway } = useSelector((store: RootStateType) => store.selectedPortfiolio);
  const { isCustFamilyHead } = useSelector((store: RootStateType) => store.id);
  const { path } = useRouteMatch();
  const { pathname } = useLocation();
  const familyView = isFamilyView(pathname)

  // console.log("LOCATION", pathname.split('/'))



  const [menuAnchorEl, setMenuAnchorEl] = React.useState<null | HTMLElement>(null);
  // const openMenu = Boolean(menuAnchorEl);
  // const handleClick = (event: React.MouseEvent<HTMLElement>) => {
  //   setMenuAnchorEl(event.currentTarget);
  // };
  // const handleClose = () => {
  //   setMenuAnchorEl(null);
  // };
  // console.log("PATH COMMON", path);

  const { investorClientId = "" } = useSelector((store: RootStateType) => store.id)

  useEffect(() => {
    if (pathname.includes('investor-dashboard') && pathname.split('/').length === 2) {
      setOpen('');
    }
    if (pathname.split("/").length > 2 && pathname.includes('investor-dashboard') && (
      pathname.includes('/mutual-fund') ||
      pathname.includes('/direct-equity') ||
      pathname.includes('/pms') ||
      pathname.includes('/debt') ||
      pathname.includes('/alternates')
    )) {
      setOpen('invest')
    }
    if (pathname.split("/").length > 2 && pathname.includes('investor-dashboard') && (
      pathname.includes('/investor-reports') ||
      pathname.includes('/analytics')
    )) {
      setOpen('others')
    }
  }, [pathname])

  const clearFamilyId = async () => {
    await dispatch(storeFamilyMemberId({ familyMemberId: "" }));
    await dispatch(storeSelectedPortfolio({ label: '', value: '' }));
    await dispatch(clearSelectedPortfolioObj());
  }

  // Used by sidebar navigations (asset classes, Analytics, Banks, Nominee,
  // Logo, etc.) where the destination always belongs to the LOGGED-IN
  // investor, not the family member that may currently be open. We exit the
  // family flow (clear `familyMemberId`) and restore the full logged-in
  // portfolio context (selected portfolio, selected portfolio object,
  // portfolio dropdown list, and held-away status) so subsequent screens
  // (e.g. MF / SIF / PMS / AIF) read the correct context. The Dashboard
  // sidebar button intentionally keeps using `clearFamilyId` since the
  // dashboard re-fetches and resets the portfolio itself.
  const restoreLoggedInPortfolio = async () => {
    await dispatch(storeFamilyMemberId({ familyMemberId: "" }));
    await dispatch(storeSelectedPortfolio(loggedInSelectedPortfolio ?? { label: '', value: '' }));
    await dispatch(storeSelectedPortfolioObj(loggedInSelectedPortfolioObj ?? {}));
    await dispatch(storePortfolioList(loggedInPortfolioList ?? []));
    await dispatch(setPortfolioHeldawayStatus(loggedInIsPortfolioHeldaway ?? false));
  }

  const handleAnalyticsNavigation = (ele: any) => {
    // history.push(ele.link);
    restoreLoggedInPortfolio();
    window.open(ele.link, '_blank');
    setOpen('');
    onToggleClick();
  }

  const handleBanksNavigation = (ele: any) => {
    restoreLoggedInPortfolio();
    history.push(ele.link);
    setOpen('');
    onToggleClick();
  }

  const handleNomineeNavigation = (ele: any) => {
    restoreLoggedInPortfolio();
    history.push(ele.link);
    setOpen('');
    onToggleClick();
  }

  const handleFamiliesNavigation = (ele: any) => {
    history.push(ele.link);
    setOpen('');
    onToggleClick();
  }



  const onLogoClick = () => {
    restoreLoggedInPortfolio();
    history.push('/');
  }

  const invFamilyLinks = [
    {
      label: 'View Family',
      link: '/investor-family/invFamRouteCheck'
    }
  ]
  return (
    <Box>
      <>
        <Box
          component="img"
          onClick={onLogoClick}
          src="/images/thriveiti_logo.png"
          alt="Thriveiti - Go to home"
          sx={{
            width: '10rem',
            height: '50px',
            margin: "25px 15px 30px 50px",
            cursor: 'pointer',
            objectFit: 'contain',
            borderRadius: '4px',
            '&:focus-visible': {
              outline: 'none !important',
              boxShadow: '0 0 0 2px #0a6b74',
            }
          }}
          tabIndex={0}
          role="link"
          onKeyDown={(e: React.KeyboardEvent) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              onLogoClick();
            }
          }}
        />
        <List
          sx={{
            ml: '1.5rem',
            mr: '1.5rem',
            '& .MuiListItemButton-root': {
              flexDirection: { xs: 'row', md: 'row' },
              '& .MuiListItemText-root': { mx: { xs: 1, md: 0 } },
              '& .MuiListItemText-root span': {
                fontFamily: `${theme.typography.fontFamily}`,
                fontSize: 16,
                fontWeight: 500,
              },
            },
            '& .MuiIconButton-root': {
              padding: '0px'
            },
            display: 'flex',
            flexDirection: 'column',
            gap: '35px',
          }}>
          {/* <Box sx={{ display: { xs: 'flex', md: 'none' }, justifyContent: 'flex-end' }}>
            <IconButton
              onClick={onToggleClick}
              aria-label="close drawer"
              sx={{ color: 'text.secondary' }}>
              <CancelIcon />
            </IconButton>
          </Box> */}

          {/* Dashboard and Recommendations */}
          <Box>

            {/* Dashboard */}

            <Button
              sx={(theme: Theme) => ({
                display: 'flex',
                columnGap: '15px',
                justifyContent: 'flex-start',
                alignItems: 'center',
                padding: '12px 15px',
                mt: '10px',
                width: '100%',
                borderRadius: '15px',
                backgroundColor: ((pathname.split("/").length === 2 && pathname.includes('investor-dashboard')) || (pathname.includes('investor-family') && !pathname.includes('family-profile') && isCustFamilyHead === 'Y' && !familyView)) ? theme.palette.primary[500] : theme.palette.common.white,
                '&:hover': {
                  backgroundColor: ((pathname.split("/").length === 2 && pathname.includes('investor-dashboard')) || (pathname.includes('investor-family') && !pathname.includes('family-profile') && isCustFamilyHead === 'Y' && !familyView)) ? theme.palette.primary[500] : theme.palette.grey[100],
                },
                "&:disabled": {
                  backgroundColor: theme.palette.grey[100],
                  cursor: "not-allowed",
                  pointerEvents: 'all',
                }
              })}
              aria-label="Dashboard"
              aria-current={((pathname.split("/").length === 2 && pathname.includes('investor-dashboard')) || (pathname.includes('investor-family') && !pathname.includes('family-profile') && isCustFamilyHead === 'Y' && !familyView)) ? 'page' : undefined}
              onClick={async () => {
                await clearFamilyId();
                history.push('/investor-dashboard');
                onToggleClick();
              }}
            >
              {((pathname.split("/").length === 2 && pathname.includes('investor-dashboard')) || (pathname.includes('investor-family') && !pathname.includes('family-profile') && isCustFamilyHead === 'Y' && !familyView)) ? <SidebarDashboardIcon /> : <DashboardInactiveIcon />}
              <Typography
                variant='body_500'
                sx={(theme: Theme) => ({
                  color: ((pathname.split("/").length === 2 && pathname.includes('investor-dashboard')) || (pathname.includes('investor-family') && !pathname.includes('family-profile') && isCustFamilyHead === 'Y' && !familyView)) ? theme.palette.common.white : theme.palette.text.secondary,
                  fontWeight: 500
                })}
              >
                Dashboard
              </Typography>
            </Button>

            {/* Recommendations */}

            <Button
              sx={(theme: Theme) => ({
                display: 'flex',
                columnGap: '15px',
                justifyContent: 'flex-start',
                alignItems: 'center',
                padding: '12px 15px',
                mt: '10px',
                width: '100%',
                borderRadius: '15px',
                backgroundColor: (path.includes('investor-recommendations') && !familyView) ? theme.palette.primary[500] : theme.palette.common.white,
                '&:hover': {
                  backgroundColor: (path.includes('investor-recommendations') && !familyView) ? theme.palette.primary[500] : theme.palette.grey[100],
                },
                "&:disabled": {
                  backgroundColor: theme.palette.grey[50],
                  cursor: "not-allowed",
                  pointerEvents: 'all',
                  opacity: 0.5
                }
              })}
              onClick={async () => {
                dispatch(setRecommendationsActiveCategories({
                  primaryCategory: "New Purchase",
                  secondaryCategory: "Lumpsum"
                }))
                dispatch(setAppliedRecommendationsFilters([]))

                // await clearFamilyId();
                history.push('/investor-recommendations');
                onToggleClick();

              }}
              disabled={!isPortfolioAvailable}
            >
              <RecommendationsIcon />
              <Typography
                variant='body_500'
                sx={(theme: Theme) => ({
                  color: (path.includes('investor-recommendations') && !familyView) ? theme.palette.common.white : theme.palette.text.secondary,
                  fontWeight: 500
                })}
              >
                Recommendations
              </Typography>
            </Button>
          </Box>

          {/* Invest and Others */}
          <Box>

            {/* Invest */}
            <Box sx={{ display: 'flex', flexDirection: 'column', }}>
              <Button
                sx={(theme: Theme) => ({
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  padding: "3px",
                  "&:hover": {
                    backgroundColor: "transparent"
                  },
                  "&:disabled": {
                    backgroundColor: theme.palette.grey[50],
                    cursor: "not-allowed",
                    pointerEvents: 'all',
                    opacity: 0.5
                  }
                })}
                onClick={() => setOpen(open === 'invest' ? '' : 'invest')}
                disabled={!isPortfolioAvailable}
                aria-expanded={open === 'invest'}
                aria-label="Invest section"
              >
                <Typography
                  variant="body_500"
                  sx={{ fontWeight: '600', color: 'text.primary' }}
                >
                  INVEST
                </Typography>
                {open === 'invest' ? <IconButton
                  onClick={() => setOpen('')}
                  aria-label="Collapse invest menu">
                  <ExpandLessIcon sx={{ color: 'text.primary' }} />
                </IconButton> : <IconButton
                  onClick={() => setOpen('invest')}
                  aria-label="Expand invest menu"
                  tabIndex={-1}>
                  <ExpandMoreIcon sx={{ color: 'text.primary' }} />
                </IconButton>}
              </Button>


              {open === 'invest' && (
                <Box
                  sx={{
                    textAlign: 'center',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '10px',
                    '.MuiTypography-root': {

                      // fontSize: '16px',
                      display: 'block',
                      textDecoration: 'none',

                    },
                  }}>
                  <Box
                    sx={(theme: Theme) => ({
                      display: 'flex',
                      justifyContent: 'flex-start',
                      alignItems: 'center',
                      columnGap: '15px',
                      padding: '12px 15px',
                      borderRadius: '15px',
                      backgroundColor: (pathname.includes('investor-dashboard') || !familyView) && pathname.includes('mutual-fund') ? theme.palette.primary[500] : theme.palette.common.white,
                      cursor: "pointer",
                      '&:hover': {
                        backgroundColor: (pathname.includes('investor-dashboard') || !familyView) && pathname.includes('mutual-fund') ? theme.palette.primary[500] : theme.palette.grey[100],
                      }
                    })}
                    onClick={() => {
                      restoreLoggedInPortfolio();
                      history.push(`/investor-dashboard/mutual-fund?tab=Overview&portfolio=${loggedInSelectedPortfolio?.value ?? ""}`, {
                        clientCode: investorClientId ?? ""
                      });
                      onToggleClick();
                    }}
                  >
                    {(pathname.includes('investor-dashboard') || !familyView) && pathname.includes('mutual-fund') ? <InvestorMFActiveIcon /> : <MutualFundsIcon />}
                    <Typography
                      variant='subtitle_500'
                      component={RouterLink}
                      to="/investor-dashboard/mutual-fund"
                      sx={(theme: Theme) => ({
                        color: (pathname.includes('investor-dashboard') || !familyView) && pathname.includes('mutual-fund') ? theme.palette.common.white : theme.palette.text.secondary,
                        // fontWeight: 500
                      })}
                    >
                      Mutual Funds
                    </Typography>
                    {/* <MutualFundsIcon />
                    <Typography
                      variant="subtitle_500"
                      component={RouterLink}
                      to="/investor-dashboard/mutual-fund"

                    >
                      Mutual Funds
                    </Typography> */}
                  </Box>
                  <Box
                    component={'button'}
                    sx={(theme: Theme) => ({
                      display: 'flex',
                      justifyContent: 'flex-start',
                      alignItems: 'center',
                      columnGap: '15px',
                      padding: '12px 15px',
                      borderRadius: '15px',
                      cursor: "pointer",
                      // backgroundColor: pathname.includes('debt') ? theme.palette.primary[500] : theme.palette.common.white,
                      // '&:hover': {
                      //   backgroundColor: pathname.includes('debt') ? theme.palette.primary[500] : theme.palette.grey[100],
                      // }
                      border: "none",
                      backgroundColor: theme.palette.common.white,
                      '&:hover': {
                        backgroundColor: theme.palette.grey[100],
                        padding: '10px',
                        borderRadius: '10px'
                      },
                      '&:disabled': {
                        backgroundColor: theme.palette.grey[50],
                        padding: '10px',
                        borderRadius: '10px',
                        cursor: "not-allowed"
                      }
                    })}
                    // onClick={() => history.push('/investor-dashboard/debt')}
                    onClick={() => {
                      restoreLoggedInPortfolio();
                      onToggleClick();
                      history.push('/investor-dashboard/debt')
                    }}
                    disabled={!isPortfolioAvailable || !(assetClassObj?.debt)}
                  >
                    {pathname.includes('investor-dashboard') && pathname.includes('debt') ? <BondsActiveIcon /> : <BondsIcon />}
                    <Typography
                      // style={{ textWrap: 'nowrap', fontSize: '15px' }}
                      sx={(theme: Theme) => ({
                        color: pathname.includes('investor-dashboard') && pathname.includes('debt') ? theme.palette.common.white : theme.palette.text.secondary,
                        // fontWeight: 500
                      })}
                      // component={RouterLink}
                      // to="/investor-dashboard/debt"
                      variant="subtitle_500"
                    // color="text.secondary"
                    >
                      Debt & Bonds
                    </Typography>
                  </Box>

                  <Box
                    component={'button'}
                    sx={(theme: Theme) => ({
                      display: 'flex',
                      justifyContent: 'flex-start',
                      alignItems: 'center',
                      columnGap: '15px',
                      padding: '12px 15px',
                      borderRadius: '15px',
                      backgroundColor: (pathname.includes('investor-dashboard') || !familyView) && pathname.includes('pms') ? theme.palette.primary[500] : theme.palette.common.white,
                      cursor: "pointer",
                      '&:hover': {
                        backgroundColor: (pathname.includes('investor-dashboard') || !familyView) && pathname.includes('pms') ? theme.palette.primary[500] : theme.palette.grey[100],
                      },
                      border: "none",
                      // backgroundColor: theme.palette.common.white,
                      // '&:hover': {
                      //   backgroundColor: theme.palette.grey[100],
                      //   padding: '10px',
                      //   borderRadius: '10px'
                      // },
                      '&:disabled': {
                        backgroundColor: theme.palette.grey[50],
                        padding: '10px',
                        borderRadius: '10px',
                        cursor: "not-allowed"
                      }
                    })}
                    onClick={() => { restoreLoggedInPortfolio(); history.push('/investor-dashboard/pms'); onToggleClick(); }}
                    disabled={!isPortfolioAvailable || !(assetClassObj?.pms)}
                  >
                    {pathname.includes('pms') ? <PMSActiveIcon /> : <PMSIcon />}
                    <Typography
                      // style={{ textWrap: 'nowrap', fontSize: '15px' }}
                      sx={(theme: Theme) => ({
                        color: (pathname.includes('investor-dashboard') || !familyView) && pathname.includes('pms') ? theme.palette.common.white : theme.palette.text.secondary,
                        // fontWeight: 500
                      })}
                      // component={RouterLink}
                      // to="/investor-dashboard/pms"
                      variant="body_500"
                    // color="text.secondary"
                    >
                      PMS
                    </Typography>
                  </Box>

                  <Box
                    component={'button'}
                    sx={(theme: Theme) => ({
                      display: 'flex',
                      justifyContent: 'flex-start',
                      alignItems: 'center',
                      columnGap: '15px',
                      padding: '12px 15px',
                      borderRadius: '15px',
                      backgroundColor: (pathname.includes('investor-dashboard') || !familyView) && pathname.includes('alternates') ? theme.palette.primary[500] : theme.palette.common.white,
                      cursor: "pointer",
                      '&:hover': {
                        backgroundColor: (pathname.includes('investor-dashboard') || !familyView) && pathname.includes('alternates') ? theme.palette.primary[500] : theme.palette.grey[100],
                      },
                      border: "none",
                      // backgroundColor: theme.palette.common.white,
                      // '&:hover': {
                      //   backgroundColor: theme.palette.grey[100],
                      //   padding: '10px',
                      //   borderRadius: '10px'
                      // },
                      '&:disabled': {
                        backgroundColor: theme.palette.grey[50],
                        padding: '10px',
                        borderRadius: '10px',
                        cursor: "not-allowed"
                      }
                    })}
                    onClick={() => { restoreLoggedInPortfolio(); history.push('/investor-dashboard/alternates'); onToggleClick(); }}
                    disabled={!isPortfolioAvailable || !(assetClassObj?.alternates)}
                  >
                    {pathname.includes('investor-dashboard') && pathname.includes('alternates') ? <AIFActiveIcon /> : <AIFIcon />}
                    <Typography
                      // style={{ textWrap: 'nowrap', fontSize: '15px' }}
                      sx={(theme: Theme) => ({
                        color: (pathname.includes('investor-dashboard') || !familyView) && pathname.includes('alternates') ? theme.palette.common.white : theme.palette.text.secondary,
                        // fontWeight: 500
                      })}
                      // component={RouterLink}
                      // to="/investor-dashboard/alternates"
                      variant="body_500"
                    // color="text.secondary"
                    >
                      Alternates
                    </Typography>
                  </Box>

                  <Box
                    component={'button'}
                    sx={(theme: Theme) => ({
                      display: 'flex',
                      justifyContent: 'flex-start',
                      alignItems: 'center',
                      columnGap: '15px',
                      padding: '12px 15px',
                      borderRadius: '15px',
                      border: "none",
                      backgroundColor: (pathname.includes('investor-dashboard') || !familyView) && pathname.includes('direct-equity') ? theme.palette.primary[500] : theme.palette.common.white,
                      cursor: "pointer",
                      '&:hover': {
                        backgroundColor: (pathname.includes('investor-dashboard') || !familyView) && pathname.includes('direct-equity') ? theme.palette.primary[500] : theme.palette.grey[100],
                      },
                      // backgroundColor: theme.palette.common.white,
                      // '&:hover': {
                      //   backgroundColor: theme.palette.grey[100],
                      //   padding: '10px',
                      //   borderRadius: '10px'
                      // },
                      '&:disabled': {
                        backgroundColor: theme.palette.grey[50],
                        padding: '10px',
                        borderRadius: '10px',
                        cursor: "not-allowed"
                      }
                    })}
                    onClick={() => { restoreLoggedInPortfolio(); history.push('/investor-dashboard/direct-equity'); onToggleClick(); }}
                    disabled={!isPortfolioAvailable || !(assetClassObj?.direct_equity)}
                  >
                    {pathname.includes('investor-dashboard') && pathname.includes('direct-equity') ? <DirectEquityActiveIcon /> : <DirectEquityIcon />}
                    <Typography
                      variant="body_500"
                      // component={RouterLink}
                      // to="/investor-direct-equity"
                      // to="/investor-dashboard/direct-equity"
                      sx={(theme: Theme) => ({
                        color: (pathname.includes('investor-dashboard') || !familyView) && pathname.includes('direct-equity') ? theme.palette.common.white : theme.palette.text.secondary,
                        // fontWeight: 500
                      })}
                    >
                      Direct Equity
                    </Typography>
                  </Box>

                </Box>
              )}
            </Box>

            {/* Family */}
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '2px', mt: '30px' }}>
              <Button
                sx={(theme: Theme) => ({
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  padding: "3px",
                  "&:hover": {
                    backgroundColor: "transparent"
                  },
                  "&:disabled": {
                    backgroundColor: theme.palette.grey[50],
                    cursor: "not-allowed",
                    pointerEvents: 'all',
                    opacity: 0.5
                  }
                })}
                onClick={() => setOpen(open === 'family' ? '' : 'family')}
                disabled={!isPortfolioAvailable}
              >
                <Typography
                  variant="body_500"
                  sx={{ fontWeight: '600', color: 'text.primary' }}
                >
                  MANAGE FAMILY
                </Typography>
                {open === 'family' ? (
                  <IconButton
                    onClick={() => setOpen('')}
                    aria-label="Collapse family menu">
                    <ExpandLessIcon sx={{ color: 'text.primary' }} />
                  </IconButton>
                ) : (
                  <IconButton
                    onClick={() => setOpen('family')}
                    aria-label="Expand family menu"
                    tabIndex={-1}>
                    <ExpandMoreIcon sx={{ color: 'text.primary' }} />
                  </IconButton>
                )}
              </Button>
              {open === 'family' && (
                <Box
                  sx={{
                    textAlign: 'center',
                    padding: '12px 15px',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '4px',
                    '.MuiTypography-root': {
                      display: 'block',
                      textDecoration: 'none',
                      color: 'text.secondary',

                    },
                  }}>
                  {invFamilyLinks.map((ele, index) => (
                    <Box
                      key={index}
                      sx={{
                        display: 'flex',
                        justifyContent: 'flex-start',
                        alignItems: 'center',
                        columnGap: '15px',
                        marginBottom: index == 1 ? 0 : '12px',
                        cursor: 'pointer',
                        padding: index === 0 ? "10px" : "6px",
                        '&:hover': {
                          backgroundColor: theme.palette.grey[100],
                          padding: index === 0 ? "10px" : "6px",
                          borderRadius: '10px'
                        }
                      }}
                      onClick={() => handleFamiliesNavigation(ele)}
                    >
                      {index === 0 && <ManageFamilyIcon />}
                      <Typography
                        variant="subtitle_500"
                        component={RouterLink}
                        to={ele.link}
                        sx={{ textAlign: 'left' }}
                        onClick={() => {
                          dispatch(getParams(initialState));
                        }}>
                        {ele.label}
                      </Typography>
                    </Box>
                  ))}
                </Box>
              )}
            </Box>


            {/* Banks */}

            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '2px', mt: '30px' }}>
              <Button
                sx={(theme: Theme) => ({
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  padding: "3px",
                  "&:hover": {
                    backgroundColor: "transparent"
                  },
                  "&:disabled": {
                    backgroundColor: theme.palette.grey[50],
                    cursor: "not-allowed",
                    pointerEvents: 'all',
                    opacity: 0.5
                  }
                })}
                onClick={() => setOpen(open === 'banks' ? '' : 'banks')}
                disabled={
                  (`${bseClientActivationStatus ?? ""}`.toLowerCase() !== "active") || !isPortfolioAvailable
                }
                aria-expanded={open === 'banks'}
                aria-label="Banks section"
              >
                <Typography
                  variant="body_500"
                  sx={{ fontWeight: '600', color: 'text.primary' }}
                >
                  BANKS
                </Typography>
                {open === 'banks' ? (
                  <IconButton
                    onClick={() => setOpen('')}
                    aria-label="Collapse banks menu">
                    <ExpandLessIcon sx={{ color: 'text.primary' }} />
                  </IconButton>
                ) : (
                  <IconButton
                    onClick={() => setOpen('banks')}
                    aria-label="Expand banks menu"
                    tabIndex={-1}>
                    <ExpandMoreIcon sx={{ color: 'text.primary' }} />
                  </IconButton>
                )}
              </Button>
              {open === 'banks' && (
                <Box
                  sx={{
                    textAlign: 'center',
                    padding: '12px 15px',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '4px',
                    '.MuiTypography-root': {
                      display: 'block',
                      textDecoration: 'none',
                      color: 'text.secondary',

                    },
                  }}>
                  {bankLinks.map((ele, index) => (
                    <Box
                      key={index}
                      sx={{
                        display: 'flex',
                        justifyContent: 'flex-start',
                        alignItems: 'center',
                        columnGap: '15px',
                        marginBottom: index == 1 ? 0 : '12px',
                        cursor: 'pointer',
                        padding: index === 0 ? "10px" : "6px",
                        '&:hover': {
                          backgroundColor: theme.palette.grey[100],
                          padding: index === 0 ? "10px" : "6px",
                          borderRadius: '10px'
                        }
                      }}
                      onClick={() => handleBanksNavigation(ele)}
                    >
                      {index === 0 && <BlueNavigationEditIcon />}
                      {index === 1 && <ViewExistingIcon />}
                      <Typography
                        variant="subtitle_500"
                        component={RouterLink}
                        to={ele.link}
                        sx={{ textAlign: 'left' }}
                        onClick={() => {
                          dispatch(getParams(initialState));
                        }}>
                        {ele.label}
                      </Typography>
                    </Box>
                  ))}
                </Box>
              )}
            </Box>

            {/* Nominee */}

            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '2px', mt: "30px" }}>
              <Button
                sx={(theme: Theme) => ({
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  padding: "3px",
                  "&:hover": {
                    backgroundColor: "transparent"
                  },
                  "&:disabled": {
                    backgroundColor: theme.palette.grey[50],
                    cursor: "not-allowed",
                    pointerEvents: 'all',
                    opacity: 0.5
                  }
                })}
                onClick={() => setOpen(open === 'nominee' ? '' : 'nominee')}
                disabled={(`${bseClientActivationStatus ?? ""}`.toLowerCase() !== "active") || !isPortfolioAvailable}
                aria-expanded={open === 'nominee'}
                aria-label="Nominee section"
              >
                <Typography
                  variant="body_500"
                  sx={{ fontWeight: '600', color: 'text.primary' }}
                >
                  NOMINEE
                </Typography>
                {open === 'nominee' ? (
                  <IconButton
                    onClick={() => setOpen('')}
                    aria-label="Collapse nominee menu">
                    <ExpandLessIcon sx={{ color: 'text.primary' }} />
                  </IconButton>
                ) : (
                  <IconButton
                    onClick={() => setOpen('nominee')}
                    aria-label="Expand nominee menu"
                    tabIndex={-1}>
                    <ExpandMoreIcon sx={{ color: 'text.primary' }} />
                  </IconButton>
                )}
              </Button>
              {open === 'nominee' && (
                <Box
                  sx={{
                    textAlign: 'center',
                    padding: '12px 0px',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '4px',
                    '.MuiTypography-root': {
                      display: 'block',
                      textDecoration: 'none',
                      color: 'text.secondary',

                    },
                  }}>
                  {nomineeLinks.map((ele, index) => (
                    <Box
                      key={index}
                      sx={{
                        display: 'flex',
                        justifyContent: 'flex-start',
                        alignItems: 'center',
                        columnGap: '15px',
                        marginBottom: index == 1 ? 0 : '12px',
                        cursor: 'pointer',
                        padding: index === 0 ? "10px" : "6px",
                        '&:hover': {
                          backgroundColor: theme.palette.grey[100],
                          padding: index === 0 ? "10px" : "6px",
                          borderRadius: '10px'
                        }
                      }}
                      onClick={() => handleNomineeNavigation(ele)}
                    >
                      {index === 0 && <BlueNavigationEditIcon />}
                      {index === 1 && <ViewExistingIcon />}
                      <Typography
                        variant="subtitle_500"
                        component={RouterLink}
                        to={ele.link}
                        sx={{ textAlign: 'left' }}
                        onClick={() => {
                          dispatch(getParams(initialState));
                        }}>
                        {ele.label}
                      </Typography>
                    </Box>
                  ))}
                </Box>
              )}
            </Box>


            {/* Others */}
            <Box sx={{ display: 'flex', flexDirection: 'column', mt: '30px' }}>
              {/* OTHERS Header */}
              <Button
                sx={(theme: Theme) => ({
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  padding: "3px",
                  "&:hover": {
                    backgroundColor: "transparent"
                  },
                  "&:disabled": {
                    backgroundColor: theme.palette.grey[50],
                    cursor: "not-allowed",
                    pointerEvents: 'all',
                    opacity: 0.5
                  }
                })}
                onClick={() => setOpen(open === 'others' ? '' : 'others')}
                disabled={!isPortfolioAvailable}
              >
                <Typography
                  variant="body_500"
                  sx={{ fontWeight: '600', color: 'text.primary', textAlign: 'left' }}
                >
                  REPORTS AND ANALYTICS
                </Typography>
                {open === 'others' ? (
                  <ExpandLessIcon sx={{ color: 'text.primary' }} />
                ) : (
                  <ExpandMoreIcon sx={{ color: 'text.primary' }} />
                )}
              </Button>

              {/* OTHERS Content */}
              {open === 'others' && (
                <Box
                  sx={{
                    textAlign: 'center',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '10px',
                    '.MuiTypography-root': {
                      display: 'block',
                      textDecoration: 'none',
                    },
                  }}
                >
                  {/* Reports */}
                  <Box
                    sx={(theme: Theme) => ({
                      display: 'flex',
                      justifyContent: 'flex-start',
                      alignItems: 'center',
                      columnGap: '15px',
                      padding: '12px 15px',
                      borderRadius: '15px',
                      backgroundColor: pathname.includes('investor-reports') ? theme.palette.primary[500] : theme.palette.common.white,
                      cursor: 'pointer',
                      '&:hover': {
                        backgroundColor: pathname.includes('investor-reports') ? theme.palette.primary[500] : theme.palette.grey[100],
                      },
                    })}
                    onClick={() => {
                      history.push('/investor-reports');
                      onToggleClick();
                    }}
                  >
                    {pathname.includes('/investor-reports') ? <InvestorActiveReportsIcon /> : <InvestorReportsIcon />}
                    <Typography
                      variant="subtitle_500"
                      component={RouterLink}
                      to="/investor-reports"
                      sx={(theme: Theme) => ({
                        color: pathname.includes('investor-reports') ? theme.palette.common.white : theme.palette.text.secondary,
                      })}
                    >
                      Reports
                    </Typography>
                  </Box>

                  {/* Analytics */}
                  {analyticsLinks.map((ele, index) => (
                    <Box
                      component="button"
                      key={index}
                      sx={(theme: Theme) => ({
                        display: 'flex',
                        justifyContent: 'flex-start',
                        alignItems: 'center',
                        columnGap: '15px',
                        padding: '12px 15px',
                        border: 'none',
                        borderRadius: '15px',
                        backgroundColor: pathname.includes('analytics') ? theme.palette.primary[500] : theme.palette.common.white,
                        cursor: 'pointer',
                        '&:hover': {
                          backgroundColor: pathname.includes('analytics') ? theme.palette.primary[500] : theme.palette.grey[100],
                        },
                      })}
                      onClick={() => handleAnalyticsNavigation(ele)}
                      disabled={ele.label === 'Mutual Fund Research' || ele.label === 'Revenue Analytics'}
                    >
                      {pathname.includes('/analytics') ? (
                        <InvestorActiveReportsIcon />
                      ) : (
                        <InvestorReportsIcon />
                      )}
                      <Typography
                        variant="subtitle_500"
                        // component={RouterLink}
                        // to="/analytics"
                        sx={(theme: Theme) => ({
                          color: pathname.includes('analytics') ? theme.palette.common.white : theme.palette.text.secondary,
                        })}
                      >
                        {ele.label}
                      </Typography>
                    </Box>
                  ))}


                  {/* Analytics Header inside Others */}
                  {/* <Box
                    sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer', padding: '0 10px', mt: '10px' }}
                    onClick={() => setOpenSub(openSub === 'analytics' ? '' : 'analytics')}
                  >
                    <Typography variant="body_500" sx={{ color: 'text.primary' }}>
                      ANALYTICS
                    </Typography>
                    {openSub === 'analytics' ? (
                      <ExpandLessIcon sx={{ color: 'text.primary' }} />
                    ) : (
                      <ExpandMoreIcon sx={{ color: 'text.primary' }} />
                    )}
                  </Box> */}

                  {/* Analytics Nested Content */}
                  {openSub === 'analytics' && (
                    <Box
                      sx={{
                        textAlign: 'center',
                        padding: '0 15px',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '8px',
                        '.MuiTypography-root': {
                          display: 'block',
                          textDecoration: 'none',
                          color: 'text.secondary',
                        },
                      }}
                    >
                      {analyticsLinks.map((ele, index) => (
                        <Box
                          component="button"
                          key={index}
                          sx={{
                            display: 'flex',
                            justifyContent: 'flex-start',
                            alignItems: 'center',
                            columnGap: '15px',
                            cursor: 'pointer',
                            padding: '10px',
                            border: 'none',
                            backgroundColor: theme.palette.common.white,
                            '&:hover': {
                              backgroundColor: theme.palette.grey[100],
                              borderRadius: '10px',
                            },
                            '&:disabled': {
                              backgroundColor: theme.palette.grey[50],
                              borderRadius: '10px',
                              cursor: 'not-allowed',
                            },
                          }}
                          onClick={() => handleAnalyticsNavigation(ele)}
                          disabled={ele.label === 'Mutual Fund Research' || ele.label === 'Revenue Analytics'}
                        >
                          <Typography
                            sx={{
                              padding: 0,
                              margin: 0,
                              fontFamily: `${theme.typography.fontFamily}`,
                            }}
                            variant="subtitle_500"
                          >
                            {ele.label}
                          </Typography>
                        </Box>
                      ))}
                    </Box>
                  )}
                </Box>
              )}
            </Box>

          </Box>
        </List>
      </>
    </Box >
  );
};


export const InvestorSidenav = ({
  mobileOpen,
  setMobileOpen,
  handleDrawerToggle,
  handleToggle
}: {
  mobileOpen: boolean;
  setMobileOpen: Dispatch<SetStateAction<boolean>>;
  handleDrawerToggle: () => void;
  handleToggle: () => void;
}): JSX.Element => {
  return (
    <>
      <Box
        component="nav"
        sx={(theme: Theme) => ({
          // width: { md: drawerWidth },
          // flexShrink: { md: 0 },
          [theme.breakpoints.up(1400)]: {
            width: drawerWidth,
            flexShrink: 0
          },
        })}
        aria-label="Sidebar navigation">
        {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          anchor="left"
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={(theme: Theme) => ({
            display: {
              xs: 'block',
              // md: 'none' 
            },
            [theme.breakpoints.up(1400)]: {
              display: "none"
            },
            '& .MuiDrawer-paper': {
              boxSizing: 'border-box',
              width: drawerWidth,
            },
          })}>
          <InvestorLoginDrawer onToggleClick={() => setMobileOpen(!mobileOpen)} />
        </Drawer>
        <Drawer
          variant="permanent"
          sx={(theme: Theme) => ({
            display: {
              // xs: 'none', 
              md: 'block'
            },
            [theme.breakpoints.down(1400)]: {
              display: "none"
            },
            '& .MuiDrawer-paper': {
              boxSizing: 'border-box',
              width: drawerWidth,
              border: 0,
              minHeight: '100vh',
              overflow: 'auto',
            },
            '& .MuiDrawer-paper::-webkit-scrollbar': {
              width: '5px', // Width of the scrollbar
            },
            '& .MuiDrawer-paper::-webkit-scrollbar-thumb': {
              backgroundColor: 'rgba(0, 0, 0, 0.5)', // Color of the scrollbar thumb
              borderRadius: '10px', // Rounded corners of the scrollbar thumb
            },
          })}
          open>
          <InvestorLoginDrawer onToggleClick={handleToggle} />
        </Drawer>
      </Box>
    </>
  );
};
export const CommonLayoutForInvestor = ({ children }: { children: JSX.Element }): JSX.Element => {

  const [mobileOpen, setMobileOpen] = useState(false);
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const handleToggle = () => {
    setMobileOpen(false);
  }
  return (
    <>
      <Box sx={{ display: 'flex', width: '100%' }}>
        <InvestorSidenav
          mobileOpen={mobileOpen}
          setMobileOpen={setMobileOpen}
          handleDrawerToggle={handleDrawerToggle}
          handleToggle={handleToggle}
        />
        <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', flexFlow: 1, minWidth: 0, width: '100%' }}>
          <Header handleDrawerToggle={handleDrawerToggle} />
          <Box
            component="main"
            id="main-content"
            tabIndex={-1}
            sx={(theme: Theme) => ({
              flex: 1,
              width: '100%',
              // mt: '15px',
              ml: { xs: 0, md: 0 },
              p: { xs: '0 15px 25px 15px', sm: '0 25px 25px 25px' },
              borderRadius: '50px 0 0 0',
              // bgcolor: { xs: '', md: 'rgba(247, 247, 247, 1)' },
              bgcolor: { xs: '' },
              [theme.breakpoints.down(1400)]: {
                bgcolor: theme.palette.background.default
              },
            })}>
            {/* <Container maxWidth="lg" disableGutters={true}
              sx={(theme: Theme) => ({
                [theme.breakpoints.up('xl')]: {
                  maxWidth: '100%',
                }
              })}>
              {children}
            </Container> */}
            <Container maxWidth={false} disableGutters={true} sx={{ width: '100%' }}>
              {children}
            </Container>
          </Box>
          <Box
            component="footer"
            sx={(theme: Theme) => ({
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              backgroundColor: theme.palette.common.white,
              width: '100%',
            })}>
            <Disclaimer
              text={<BottomDisclaimer />}
              containerStyles={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
              }}
            />
          </Box>
        </Box>
      </Box>
      {/* <Footer /> */}
    </>
  );
};





export const UserManagementCommonLayout = ({
  children,
}: {
  children: JSX.Element;
}): JSX.Element => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const handleToggle = () => {
    setMobileOpen(false);
  }
  return (
    <>
      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          // minHeight: 'calc(100vh - 43px)',
          // overflow: 'auto',
          flexDirection: 'column',
        }}>
        <HeaderSidenav
          mobileOpen={mobileOpen}
          setMobileOpen={setMobileOpen}
          handleDrawerToggle={handleDrawerToggle}
          handleToggle={handleToggle}
        />
        <Box
          component="main"
          sx={{
            mt: '65px',
            ml: { xs: 0, md: drawerWidth },
            p: { xs: 0, md: '50px' },
            pt: { md: '20px' },
            borderRadius: { xs: '', sm: '50px 0 0 0' },
            bgcolor: 'rgba(238, 244, 251, 0.5)',
            minHeight: 'calc(100vh - 108px)',
            //overflow: 'auto',
          }}>
          <Container maxWidth="lg" disableGutters={true}>
            {children}
          </Container>
        </Box>
      </Box>
      {/* <Footer /> */}
    </>
  );
};
export const ConfirmationDialog = ({
  open,
  setOpen,
  message = 'Are you sure you want to delete?',
  subMessage = "",
  onCancel,
  onSave,
  showIcon = false,
  icon,
  primaryButtonText = 'Yes',
  secondaryButtonText = "No"
}: {
  message: string;
  subMessage?: string;
  open: boolean;
  setOpen: () => void;
  onCancel: () => void;
  onSave: () => void;
  showIcon?: boolean;
  icon?: JSX.Element;
  primaryButtonText?: string;
  secondaryButtonText?: string
}): JSX.Element => {
  return (
    // <Dialog open={open} onClose={setOpen}>
    //   <Box
    //     sx={{
    //       p: { xs: 2, sm: '45px 40px' },
    //       borderRadius: '10px',
    //       // width: { xs: '70%', sm: '70%' },
    //       maxWidth: 400,
    //       height: { xs: '90%', md: 'unset' },
    //       overflowY: 'auto',
    //     }}>
    //     <Box
    //       sx={{
    //         display: 'flex',
    //         flexDirection: 'column',
    //         alignItems: 'center',
    //         justifyContent: 'center',
    //         '& .MuiButton-root': {
    //           minWidth: 100,
    //           fontSize: 16,
    //         },
    //       }}>
    //       <Typography
    //         sx={{
    //           fontSize: 20,
    //           fontWeight: 500,
    //           color: '#337FC9',
    //           textAlign: 'center',
    //           mb: 5,
    //         }}>
    //         {message}
    //       </Typography>
    //       <Box
    //         sx={{
    //           display: 'flex',
    //           gap: 1.5,
    //           '.MuiButton-root': {
    //             minWidth: '100px',
    //           },
    //         }}>
    //         <Button variant="contained" onClick={onSave} sx={{ color: 'common.white' }}>
    //           Yes
    //         </Button>
    //         <Button variant="outlined" onClick={onCancel} sx={{ color: 'primary.main' }}>
    //           No
    //         </Button>
    //       </Box>
    //     </Box>
    //   </Box>
    // </Dialog>
    <Dialog
      onClose={setOpen}
      open={open}
      maxWidth='sm'
      fullWidth
      sx={{
        '& .MuiPaper-root': {
          borderRadius: '15px',
          backgroundColor: "background.paper",
          rowGap: { xs: "0px", sm: "25px" },
        },
      }}
    >
      <DialogContent sx={{ paddingTop: { xs: "40px", sm: "25px" } }}>
        <Box sx={{ display: "flex", columnGap: "8px" }}>
          {showIcon ? icon || <WarningIcon /> : null}
          <Typography variant='h2' color="text.primary" mb="10px" sx={{ typography: { xs: 'h1', sm: 'h2' } }}>{message}</Typography>
        </Box>
        {subMessage &&
          <Typography
            variant='subtitle_400'
            color="text.secondary"
            sx={{
              lineHeight: "20px"
            }}
          >
            {subMessage}
          </Typography>
        }
      </DialogContent>
      <DialogActions sx={{ padding: { xs: "19px", sm: "25px" }, columnGap: "10px" }}>
        <Button
          variant="outlined"
          onClick={onCancel}
          sx={(theme: Theme) => ({
            color: theme.palette.text.secondary,
            flex: 1,
            border: `0.5px solid ${theme.palette.text.secondary}`,
            padding: "10px",
            "&:hover, &.Mui-focusVisible": {
              borderColor: theme.palette.text.secondary,
              backgroundColor: theme.palette.background.default
            }
          })}
        >
          {secondaryButtonText}
        </Button>
        <Button
          variant="contained"
          sx={(theme: Theme) => ({
            flex: 1,
            color: theme.palette.textDark.primary,
            padding: "10px"
          })}
          onClick={onSave}
        >
          {primaryButtonText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

type Props = DialogProps & {
  title?: string;
  content: string;
  actions: {
    label: string;
    onClick: () => void;
  }[];
};

export default function SimpleDialog({ title, ...props }: Props): JSX.Element {
  return (
    <Dialog
      {...props}
      aria-labelledby={title ? "simple-dialog-title" : undefined}
      aria-describedby="simple-dialog-content"
      role="alertdialog"
      sx={{
        '& .MuiPaper-root': {
          minWidth: { sx: '300px', md: '400px' },
          maxWidth: { sx: '500px', md: '500px' },
          borderRadius: '8px',
          padding: '30px 30px 20px',
          textAlign: 'center',
          color: '#4f4f4f',
        },
        '& .MuiDialogContent-root': {
          textAlign: 'center',
        },
        '& .MuiDialogActions-root': {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          '& .MuiButton-root': {
            width: '160px',
            height: '58px',
            borderRadius: '8px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '18px',
            margin: 'auto',
            marginBottom: '20px',
          },
        },
      }}>
      {title && <DialogTitle id="simple-dialog-title">{title}</DialogTitle>}
      <DialogContent>
        <DialogContentText id="simple-dialog-content">{props.content}</DialogContentText>
      </DialogContent>
      <DialogActions>
        {props.actions.map((action, index) => (
          <Button variant="contained" color="primary" key={index} onClick={action.onClick} autoFocus={index === 0}>
            {action.label}
          </Button>
        ))}
      </DialogActions>
    </Dialog>
  );
}

const POALoginDrawer = ({ onToggleClick }: { onToggleClick: () => void }) => {
  const history = useHistory();
  const theme = useTheme();
  const dispatch = useDispatch();
  const { subRole = "", role = "" } = useSelector((state: RootStateType) => state.auth);
  const [open, setOpen] = useState<'' | 'applications' | 'reports' | 'orders' | 'payments'>('');


  const { path } = useRouteMatch();
  const { pathname } = useLocation();


  const [menuAnchorEl, setMenuAnchorEl] = React.useState<null | HTMLElement>(null);

  const handleReportsNavigation = (type: string) => {
    dispatch(getParams(initialState))

    if (type === "onboardingReports") {
      history.push('/reports');

      // setOpen('');
      return
    }

  }


  useEffect(() => {
    if (pathname.split("/").length > 2 && (
      pathname.includes('/applications-list')
    )) {
      setOpen('applications')
    }
    if (pathname.split("/").length > 2 && (
      pathname.includes('/orders-approval')
    )) {
      setOpen('orders')
    }
    if (pathname.split("/").length > 2 && (
      pathname.includes('/payments-approval')
    )) {
      setOpen('payments')
    }
  }, [pathname])
  return (
    <Box>
      <>
        <CardMedia
          component="img"
          onClick={() => history.push('/')}
          src="/images/thriveiti_logo.png"
          alt="Thriveiti - Go to home"
          sx={{
            width: '10rem',
            objectFit: 'contain',
            display: {
              xs: 'block',
              margin: "25px 15px 30px 50px",
              cursor: 'pointer'
            },
          }}
        />
        <List
          sx={{
            ml: '1.5rem',
            mr: '1.5rem',
            '& .MuiListItemButton-root': {
              flexDirection: { xs: 'row', md: 'row' },
              '& .MuiListItemText-root': { mx: { xs: 1, md: 0 } },
              '& .MuiListItemText-root span': {
                fontFamily: `${theme.typography.fontFamily}`,
                fontSize: 16,
                fontWeight: 500,
              },
            },
            '& .MuiIconButton-root': {
              padding: '0px'
            },
            display: 'flex',
            flexDirection: 'column',
            gap: '35px',
          }}>

          {/* Applications and Orders */}
          <Box>

            {/* Applications */}
            <Box sx={{ display: 'flex', flexDirection: 'column', }}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: '15px', cursor: 'pointer' }}
                onClick={() => setOpen(open === 'applications' ? '' : 'applications')}
              >
                <Typography variant="body_500" sx={{ fontWeight: '600', color: 'text.primary' }}>
                  APPLICATIONS
                </Typography>
                {open === 'applications' ? <IconButton
                  onClick={() => setOpen('')}
                  aria-label="Collapse applications menu">
                  <ExpandLessIcon sx={{ color: 'text.primary' }} />
                </IconButton> : <IconButton
                  onClick={() => setOpen('applications')}
                  aria-label="Expand applications menu"
                  tabIndex={-1}>
                  <ExpandMoreIcon sx={{ color: 'text.primary' }} />
                </IconButton>}
              </Box>


              {open === 'applications' && (
                <Box
                  sx={{
                    textAlign: 'center',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '10px',
                    '.MuiTypography-root': {
                      display: 'block',
                      textDecoration: 'none',
                    },
                  }}>
                  <Box
                    component='button'
                    sx={(theme: Theme) => ({
                      display: 'flex',
                      justifyContent: 'flex-start',
                      alignItems: 'center',
                      columnGap: '15px',
                      padding: '12px 15px',
                      borderRadius: '15px',
                      border: "none",
                      backgroundColor: pathname.includes('applications-list') ? theme.palette.primary[500] : theme.palette.common.white,
                      cursor: "pointer",
                      '&:hover': {
                        backgroundColor: pathname.includes('applications-list') ? theme.palette.primary[500] : theme.palette.grey[100],
                      },
                      '&:disabled': {
                        backgroundColor: theme.palette.grey[50],
                        padding: '10px',
                        borderRadius: '10px',
                        cursor: "not-allowed"
                      }
                    })}
                    onClick={() => history.push('/applications-list')}
                    disabled={[USER_ROLES.POACHECKER].includes(subRole)}                >
                    {pathname.includes('applications-list') ? <ViewExistingIcon /> : <MutualFundsIcon />}
                    <Typography
                      variant='subtitle_500'
                      sx={(theme: Theme) => ({
                        color: pathname.includes('applications-list') ? theme.palette.common.white : theme.palette.text.secondary,
                        // fontWeight: 500
                      })}
                    >
                      View Existing
                    </Typography>
                  </Box>
                </Box>
              )}
            </Box>

            {/* Onboarding Reports */}

            <Box sx={{ display: 'flex', flexDirection: 'column', mt: '35px' }}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: '15px', cursor: 'pointer' }}
                onClick={() => setOpen(open === 'reports' ? '' : 'reports')}
              >
                <Typography variant="body_500" sx={{ fontWeight: '600', color: 'text.primary' }}>
                  REPORTS
                </Typography>
                {open === 'reports' ? <IconButton
                  onClick={() => setOpen('')}
                  aria-label="Collapse reports menu">
                  <ExpandLessIcon sx={{ color: 'text.primary' }} />
                </IconButton> : <IconButton
                  onClick={() => setOpen('reports')}
                  aria-label="Expand reports menu"
                  tabIndex={-1}>
                  <ExpandMoreIcon sx={{ color: 'text.primary' }} />
                </IconButton>}
              </Box>
              {open === 'reports' && (
                <>
                  <Box
                    sx={{
                      textAlign: 'center',
                      padding: '12px 15px',
                      '.MuiTypography-root': {
                        display: 'block',
                        textDecoration: 'none',
                        color: 'text.secondary',
                      },
                    }}>
                    <Box
                      component="button"
                      sx={(theme: Theme) => ({
                        display: 'flex',
                        justifyContent: 'flex-start',
                        alignItems: 'center',
                        columnGap: '15px',
                        cursor: 'pointer',
                        padding: '10px',
                        border: "none",
                        backgroundColor: "transparent",
                        width: "100%",
                        '&:hover': {
                          backgroundColor: theme.palette.grey[100],
                          padding: '10px',
                          borderRadius: '10px'
                        },
                        '&:disabled': {
                          backgroundColor: theme.palette.grey[50],
                          padding: '10px',
                          borderRadius: '10px',
                          cursor: "not-allowed"
                        }
                      })}
                      onClick={() => handleReportsNavigation("onboardingReports")}
                    >
                      <Box sx={{ flexShrink: 0 }}>
                        <DownloadIcon />
                      </Box>
                      <Typography
                        variant="subtitle_500"
                        sx={{ lineHeight: "20px" }}
                      >
                        Onboarding Reports
                      </Typography>
                    </Box>
                  </Box>

                </>
              )}
            </Box>



            {/* Orders */}
            {ENABLE_ORDER_MANAGEMENT && (
              <Box sx={{ display: 'flex', flexDirection: 'column', mt: '35px' }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: '15px', cursor: 'pointer' }}
                  onClick={() => setOpen(open === 'orders' ? '' : 'orders')}
                >
                  <Typography variant="body_500" sx={{ fontWeight: '600', color: 'text.primary' }}>
                    ORDERS
                  </Typography>
                  {open === 'orders' ? <IconButton
                    onClick={() => setOpen('')}
                    aria-label="Collapse orders menu">
                    <ExpandLessIcon sx={{ color: 'text.primary' }} />
                  </IconButton> : <IconButton
                    onClick={() => setOpen('orders')}
                    aria-label="Expand orders menu"
                    tabIndex={-1}>
                    <ExpandMoreIcon sx={{ color: 'text.primary' }} />
                  </IconButton>}
                </Box>


                {open === 'orders' && (
                  <Box
                    sx={{
                      textAlign: 'center',
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '10px',
                      '.MuiTypography-root': {
                        display: 'block',
                        textDecoration: 'none',
                      },
                    }}>
                    <Box
                      component={'button'}
                      sx={(theme: Theme) => ({
                        display: 'flex',
                        justifyContent: 'flex-start',
                        alignItems: 'center',
                        columnGap: '15px',
                        padding: '12px 15px',
                        borderRadius: '15px',
                        border: "none",
                        backgroundColor: pathname.includes('orders-approval') ? theme.palette.primary[500] : theme.palette.common.white,
                        cursor: "pointer",
                        '&:hover': {
                          backgroundColor: pathname.includes('orders-approval') ? theme.palette.primary[500] : theme.palette.grey[100],
                        },
                        '&:disabled': {
                          backgroundColor: theme.palette.grey[50],
                          padding: '10px',
                          borderRadius: '10px',
                          cursor: "not-allowed"
                        }
                      })}
                      onClick={() => history.push('/orders-approval')}
                      onKeyDown={(e: React.KeyboardEvent) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                          e.preventDefault();
                          history.push('/orders-approval');
                        }
                      }}
                      role="button"
                      tabIndex={0}
                      aria-label="Order Approvals"
                      aria-current={pathname.includes('/orders-approval') ? 'page' : undefined}
                      disabled={[USER_ROLES.POACHECKER].includes(subRole)}
                    >
                      {pathname.includes('/orders-approval') ? <SidebarDashboardIcon /> : <DashboardInactiveIcon />}
                      <Typography
                        variant="subtitle_500"
                        sx={(theme: Theme) => ({
                          color: pathname.includes('orders-approval') ? theme.palette.common.white : theme.palette.text.secondary,
                        })}
                      >
                        Order Approvals
                      </Typography>
                    </Box>
                  </Box>
                )}
              </Box>
            )}

            {/* Payments */}

            {ENABLE_PAYMENT_CHECKER && (
              <Box sx={{ display: 'flex', flexDirection: 'column', mt: '35px' }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: '15px', cursor: 'pointer' }}
                  onClick={() => setOpen(open === 'payments' ? '' : 'payments')}
                >
                  <Typography variant="body_500" sx={{ fontWeight: '600', color: 'text.primary' }}>
                    PAYMENTS
                  </Typography>
                  {open === 'payments' ? <IconButton
                    onClick={() => setOpen('')}
                    aria-label="Collapse payments menu">
                    <ExpandLessIcon sx={{ color: 'text.primary' }} />
                  </IconButton> : <IconButton
                    onClick={() => setOpen('orders')}
                    aria-label="Expand payments menu"
                    tabIndex={-1}>
                    <ExpandMoreIcon sx={{ color: 'text.primary' }} />
                  </IconButton>}
                </Box>


                {open === 'payments' && (
                  <Box
                    sx={{
                      textAlign: 'center',
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '10px',
                      '.MuiTypography-root': {
                        display: 'block',
                        textDecoration: 'none',
                      },
                    }}>
                    <Box
                      component={'button'}
                      sx={(theme: Theme) => ({
                        display: 'flex',
                        justifyContent: 'flex-start',
                        alignItems: 'center',
                        columnGap: '15px',
                        padding: '12px 15px',
                        borderRadius: '15px',
                        border: "none",
                        backgroundColor: pathname.includes('payments-approval') ? theme.palette.primary[500] : theme.palette.common.white,
                        cursor: "pointer",
                        '&:hover': {
                          backgroundColor: pathname.includes('payments-approval') ? theme.palette.primary[500] : theme.palette.grey[100],
                        },
                        '&:disabled': {
                          backgroundColor: theme.palette.grey[50],
                          padding: '10px',
                          borderRadius: '10px',
                          cursor: "not-allowed"
                        }
                      })}
                      onClick={() => history.push('/payments-approval')}
                      disabled={[USER_ROLES.AMCAPPROVER].includes(role) && ![USER_ROLES.POACHECKER].includes(subRole)}
                    >
                      {pathname.includes('/payments-approval') ? <PaymentsActiveIcon /> : <PaymentsInactiveIcon />}
                      <Typography
                        variant="subtitle_500"
                        sx={(theme: Theme) => ({
                          color: pathname.includes('payments-approval') ? theme.palette.common.white : theme.palette.text.secondary,
                        })}
                      >
                        Payment Approvals
                      </Typography>
                    </Box>
                  </Box>
                )}
              </Box>
            )}
          </Box>
        </List>
      </>
    </Box >
  );
};
export const POASidenav = ({
  mobileOpen,
  setMobileOpen,
  handleDrawerToggle,
}: {
  mobileOpen: boolean;
  setMobileOpen: Dispatch<SetStateAction<boolean>>;
  handleDrawerToggle: () => void;
}): JSX.Element => {

  return (
    <>
      <Box
        component="nav"
        sx={(theme: Theme) => ({
          [theme.breakpoints.up(1400)]: {
            width: drawerWidth,
            flexShrink: 0
          },
        })}
        aria-label="Sidebar navigation">
        {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          anchor="left"
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={(theme: Theme) => ({
            display: {
              xs: 'block',
            },
            [theme.breakpoints.up(1400)]: {
              display: "none"
            },
            '& .MuiDrawer-paper': {
              boxSizing: 'border-box',
              width: drawerWidth,
            },
          })}>
          <POALoginDrawer onToggleClick={() => setMobileOpen(!mobileOpen)} />
        </Drawer>
        <Drawer
          variant="permanent"
          sx={(theme: Theme) => ({
            display: {
              // xs: 'none', 
              md: 'block'
            },
            [theme.breakpoints.down(1400)]: {
              display: "none"
            },
            '& .MuiDrawer-paper': {
              boxSizing: 'border-box',
              width: drawerWidth,
              border: 0,
              minHeight: '100vh',
              overflow: 'auto',
            },
            '& .MuiDrawer-paper::-webkit-scrollbar': {
              width: '5px', // Width of the scrollbar
            },
            '& .MuiDrawer-paper::-webkit-scrollbar-thumb': {
              backgroundColor: 'rgba(0, 0, 0, 0.5)', // Color of the scrollbar thumb
              borderRadius: '10px', // Rounded corners of the scrollbar thumb
            },
          })}
          open>
          <POALoginDrawer onToggleClick={() => setMobileOpen(!mobileOpen)} />
        </Drawer>
      </Box>
    </>
  );
};
export function CommonLayoutForPOA({ children }: { children: JSX.Element }): JSX.Element {
  // const { role } = useSelector((store: RootStateType) => store.auth);
  // const dispatch = useDispatch();
  // return (
  //   <>
  //     <AppBar position="fixed" elevation={0} sx={{ bgcolor: 'common.white' }}>
  //       <Box
  //         sx={{
  //           display: 'flex',
  //           alignItems: 'center',
  //           justifyContent: 'space-between',
  //           paddingRight: { xs: 0, sm: '48px' },
  //           paddingLeft: { xs: 0, sm: '48px' },
  //         }}>
  //         <CardMedia
  //           component="img"
  //           // src="/images/kfintechHeaderImg.svg"
  //           src="/images/mPowerWealth_Logo.svg"
  //           alt="Thriveiti - Go to home"
  //           // sx={{ width: '160px', m: 2 }}
  //           sx={{
  //             width: '15rem',
  //             // padding: '1.6rem 0.7rem',
  //             // marginBottom: '10px',
  //             // marginBottom: '35px',
  //             margin: "30px 0px 30px 15px"
  //           }}
  //         />
  //         {role !== USER_ROLES.INVESTOR && (
  //           <Box sx={{ display: 'flex' }}>
  //             <IconButton onClick={() => dispatch(logout())}>
  //               <PowerSettingsNewIcon fontSize="large" sx={{ color: 'primary.main' }} />
  //             </IconButton>
  //           </Box>
  //         )}
  //       </Box>
  //     </AppBar>
  //     <Divider sx={{ display: { xs: 'block', sm: 'none' } }} />
  //   </>
  // );
  const [mobileOpen, setMobileOpen] = useState(false);
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  return (
    <>
      <Box sx={{ display: 'flex', width: '100%' }}>
        <POASidenav
          mobileOpen={mobileOpen}
          setMobileOpen={setMobileOpen}
          handleDrawerToggle={handleDrawerToggle}
        />
        <Box sx={{ display: 'flex', flexDirection: 'column', flexGrow: 1, minWidth: 0 }}>
          <Header handleDrawerToggle={handleDrawerToggle} />
          <Box
            component="main"
            sx={(theme: Theme) => ({
              ml: { xs: 0, md: 0 },
              p: { xs: '0 25px 25px 25px' },
              borderRadius: '50px 0 0 0',
              bgcolor: { xs: '' },
              [theme.breakpoints.down(1400)]: {
                bgcolor: theme.palette.background.default
              },
            })}>
            <Container maxWidth={false} disableGutters={true}>
              {children}
            </Container>
          </Box>
        </Box>
      </Box>

    </>
  )
}

export function CountryCodesDropDown({
  name,
  value,
  readOnly = false,
  disabled = false,
  ElementWidth,
}: {
  name: string;
  value: string;
  readOnly?: boolean;
  disabled?: boolean;
  ElementWidth?: number | null;
}): JSX.Element {
  const { setFieldValue } = useFormikContext();
  const [query, setQuery] = useState('');

  const theme = useTheme()

  return (
    <InputAdornment
      position="start"
      sx={{
        pr: '0 !important',
        mx: '0 !important',
      }}>
      <Box
        sx={{
          '.MuiOutlinedInput-root': {
            marginTop: '0',
            '&.MuiInputBase-root': {
              '& .MuiSelect-select': {
                // padding: '12px 15px 12px 0',
                padding: '0',
                border: 'none',
                '& .MuiBox-root': {
                  columnGap: "5px",
                  alignItems: "center"
                }
              },
            },
            '.MuiOutlinedInput-notchedOutline': {
              border: 'none',
            },
            '&.Mui-focused': {
              border: `2px solid ${theme.palette.primary.main}`,
              borderRadius: '8px',
            },
          },

          '&.Mui-focused,&:hover': {
            '.MuiOutlinedInput-notchedOutline': {
              borderWidth: 'none',
            },
          },
        }}
      >
        <Select
          name={name}
          inputProps={{ 'aria-label': 'Select country code', tabIndex: 0 }}
          sx={{
            '& .MuiSelect-select': {
              display: 'flex',
              alignItems: 'center',
              padding: '0 !important',
              '&:focus': {
                backgroundColor: 'transparent',
              },
            },
          }}
          onChange={(e) => {
            setFieldValue(name, `${e.target.value}`);
          }}
          onKeyDown={(e) => {
            // Allow Tab to move focus out of the country code dropdown
            if (e.key === 'Tab') {
              e.stopPropagation();
            }
          }}
          value={value}
          renderValue={(value) => {
            return (
              <Box sx={{ pr: "15px", mr: "5px", display: "flex", alignItems: "center", justifyContent: "center", borderRightWidth: "1.3px", borderRightStyle: "solid", borderRightColor: "text.secondary" }}>
                <Typography variant='body_500' color="text.primary">{value.split(':')[1] ? value.split(':')[1].trim() : value}</Typography>
                <DropdownIcon strokeColor={theme.palette.text.secondary} />
              </Box>
            );
          }}
          IconComponent={() => null}
          MenuProps={{
            transformOrigin: {
              vertical: 'top',
              horizontal: 'left',
            },
            anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
            sx: {
              '.MuiPaper-root ': {
                width: ElementWidth,
                ml: '-10px',
                maxHeight: '20%',
                overflowX: 'auto',
              },
            },
            disableAutoFocusItem: true,
            MenuListProps: {
              disableListWrap: true,
            },
          }}
          onClose={() => {
            setQuery('');
          }}
          readOnly={readOnly}
          disabled={disabled}
        >
          <SearchFieldWrapper searchFieldPlaceholder={'Search...'} setQuery={setQuery} />
          {renderFilteredOptions(
            getCountryCodes().map((codes) => ({
              key: codes.label,
              value: codes.label,
            })),
            query
          )}
          {/* {getCountryCodes().map((codes, ind) => (
            <MenuItem value={codes.label} key={ind}>
              {codes.label}
            </MenuItem>
          ))} */}
        </Select>
      </Box>
    </InputAdornment >
  );
}
export interface AmlPopupValues {
  amlComments: string;
  amlAcknowledgement: boolean;
}

const amlPopupInitialValues: AmlPopupValues = {
  amlComments: '',
  amlAcknowledgement: false,
};
const amlPopupValidation = yup.object().shape({
  amlComments: yup.string().required('Field is required'),
  amlAcknowledgement: yup.bool().test('amlAcknowledgement', 'Field is required', (value) => {
    return value || false;
  }),
});
export function AmlPopup({
  handleClose,
  amlPopupOpen,
  onSubmit,
  FURTHER_INFORMATION,
  EXTERNAL_SOURCES,
  displayDocInfo = false,
}: {
  handleClose: () => void;
  amlPopupOpen: boolean;
  onSubmit: (values: AmlPopupValues) => void;
  FURTHER_INFORMATION?: string;
  EXTERNAL_SOURCES?: string;
  displayDocInfo?: boolean;
}): JSX.Element {
  return (
    <Dialog
      onClose={handleClose}
      open={amlPopupOpen}
      sx={{
        '.MuiPaper-root ': {
          p: 2,
          width: { xs: '100%', sm: '70%' },
        },
      }}>
      <Box sx={{ mb: 2, mt: 1 }}>
        <CardMedia
          component="img"
          src="/images/warning-icon-red.svg"
          sx={{ width: '50px', mx: 'auto' }}
        />
      </Box>
      <Box
        sx={{
          width: { xs: '100%', sm: '89%' },
          mx: 'auto',
        }}>
        <Typography
          sx={{
            color: '#BD2932',
            textAlign: 'center',
            mb: 1,
            fontSize: 14,
            fontWeight: 500,
          }}>
          Sorry, we are unable to onboard customer at this time. Thriveiti RM to connect with back-office team.
        </Typography>
        <Typography
          sx={{
            color: 'secondary.main',
            textAlign: 'start',
            mt: 2,
            fontSize: 16,
            fontWeight: 500,
            mb: 0.5,
          }}>
          Further Information:
        </Typography>
        <Box
          sx={{
            width: '100%',
            height: '25vh',
            overflowY: 'auto',
            overflowWrap: 'anywhere',
            border: '1px solid #ccc',
            borderRadius: '5px',
          }}>
          <Typography
            sx={{
              color: 'rgba(0,0,0,0.7)',
              textAlign: 'start',
              m: 2,
              fontSize: 14,
              fontWeight: 500,
            }}>
            {FURTHER_INFORMATION || ''}
          </Typography>
          <Typography
            sx={{
              color: 'primary.main',
              textAlign: 'start',
              ml: 2,
              fontSize: 16,
              fontWeight: 600,
            }}>
            Reference Links
          </Typography>
          <Typography
            sx={{
              color: 'rgb(0, 0, 255)',
              textAlign: 'start',
              fontSize: 14,
              fontWeight: 500,
              m: 2,
              mt: 0.5,
            }}>
            {EXTERNAL_SOURCES || ''}
          </Typography>
        </Box>
        <Typography
          sx={{
            color: 'secondary.main',
            textAlign: 'start',
            fontSize: 14,
            fontWeight: 500,
            mt: 3,
            mb: 0,
          }}>
          If you still wish to proceed with this PAN, please provide reason below.
        </Typography>
        <Formik
          initialValues={amlPopupInitialValues}
          onSubmit={onSubmit}
          validationSchema={amlPopupValidation}>
          {({ handleSubmit, values }) => (
            <Box
              component="form"
              noValidate
              onSubmit={handleSubmit}
              sx={{
                fontSize: 14,
                fontWeight: 500,
                color: 'rgba(0,0,0,0.7)',
                '.MuiTypography-root': {
                  fontSize: 15,
                  fontWeight: 500,
                },
              }}>
              <MFTextField
                name="amlComments"
                multiline
                rows={3}
                inputProps={{
                  maxLength: 1024,
                }}
                placeholder="Type here..."
                displayCharecterCounter={'1024'}
                sx={{
                  color: 'rgba(0,0,0,0.7)',
                  pl: 0.5,
                  pt: 0.5,
                  '&.MuiInputBase-root': {
                    fontSize: 14,
                    fontWeight: 500,
                  },
                }}
              />
              <MFCheckbox
                name={`amlAcknowledgement`}
                label="I understand the risks and acknowledge to proceed further."
                sx={{ mt: 1 }}
              />
              {values.amlAcknowledgement && displayDocInfo && (
                <Typography
                  sx={{
                    color: 'primary.main',
                    textAlign: 'center',
                    fontSize: 14,
                    fontWeight: 500,
                    mt: 1,
                    mb: 0,
                  }}>
                  Please upload compliance document in document details.
                </Typography>
              )}
              <Grid container sx={{ mt: 3, mb: 1, justifyContent: 'center', gap: 1.5 }}>
                <Button
                  onClick={() => {
                    handleClose();
                  }}
                  variant="outlined"
                  sx={{
                    fontSize: 15,
                    color: 'primary.main',
                    minWidth: 180,
                    letterSpacing: 2,
                    fontWeight: 500,
                  }}>
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  sx={{
                    fontSize: 15,
                    minWidth: 180,
                    letterSpacing: 2,
                    fontWeight: 400,
                  }}
                  type="submit">
                  Proceed
                </Button>
              </Grid>
            </Box>
          )}
        </Formik>
      </Box>
    </Dialog>
  );
}
export function AmlDetailsFields({
  amlCheck,
  amlCommentedRole,
  amlComments,
}: {
  amlCheck: boolean | undefined;
  amlCommentedRole: string | undefined;
  amlComments: string | undefined;
}): JSX.Element {
  return (
    <Grid
      item
      container
      rowSpacing={3}
      pb={2}
      columnSpacing={13}
      direction="row"
      justifyContent="space-between"
      alignItems="flex-start"
      sx={{ paddingLeft: { xs: 0, sm: '10%' } }}>
      <KeyValue title={'Aml Check'} description={amlCheck?.toString().toUpperCase() || ''} />
      <KeyValue title={'Commented By'} description={amlCommentedRole?.toUpperCase() || ''} />
      <Grid item xs={12}>
        <Item>{'Comments'}</Item>
        <ItemDetails> {amlComments || '-'}</ItemDetails>
      </Grid>
    </Grid>
  );
}
export function AmlDetails({
  applicants = [],
  applicationType,
}: {
  applicants: Partial<Applicant>[];
  applicationType: string;
}): JSX.Element {
  return (
    <>
      {!applicants.every((applicant) => applicant.amlCheck) && (
        <Box
          sx={{
            bgcolor: 'white',
            boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.05)',
            borderRadius: '10px',
          }}
          my={5}>
          <Box sx={{ p: 2 }}>
            <Grid container sx={{ mt: 1, pl: { xs: 2, sm: 10 }, pr: { xs: 2, sm: 10 } }}>
              <Grid
                container
                direction="row"
                justifyContent="space-between"
                alignItems="flex-start">
                <Typography sx={{ fontSize: 18, fontWeight: 600, color: 'primary.main' }}>
                  Aml Check Details
                </Typography>
              </Grid>
              {applicants
                .filter((applicant) => !applicant.amlCheck)
                .map((applicant, index: number) => {
                  const title = [
                    'First Applicant Details',
                    'Second Applicant Details',
                    'Third Applicant Details',
                  ][Number(applicant.applicant_type) - 1];
                  return (
                    <React.Fragment key={applicant.id}>
                      {applicationType !== APPLICATION_TYPE.NON_INDIVIDUAL && (
                        <SubHeading
                          sx={{
                            color: 'common.black',
                            letterSpacing: 0.5 + 'px',
                            padding: { xs: '10px 10px', sm: '10px 30px' },
                          }}>
                          {title}
                        </SubHeading>
                      )}
                      <AmlDetailsFields
                        amlCheck={applicant.amlCheck}
                        amlCommentedRole={applicant.amlCommentedRole}
                        amlComments={applicant.amlComments}
                      />
                    </React.Fragment>
                  );
                })}
            </Grid>
          </Box>
        </Box>
      )}
    </>
  );
}

export const LoadingDialog = ({
  loadingPopup,
  onLoadingPopupClose,
  loaderText = 'Loading',
}: {
  loadingPopup: boolean;
  onLoadingPopupClose: () => void;
  loaderText?: string;
}): JSX.Element => {
  return (
    <Dialog
      onClose={onLoadingPopupClose}
      open={loadingPopup}
      sx={{
        '.MuiPaper-root ': {
          p: 4,
          width: { xs: '70%', sm: '70%' },
        },
      }}>
      <Box
        sx={{
          width: { xs: '100%', sm: '80%' },
          mx: 'auto',
          '.MuiTypography-root': {
            fontSize: 20,
            fontWeight: 500,
          },
        }}>
        <Typography sx={{ color: 'primary.main', lineHeight: '35px', textAlign: 'center' }}>
          {loaderText}...
        </Typography>
      </Box>
    </Dialog>
  );
};
export const CopyGraphDropdown = ({
  elementRef,
}: {
  elementRef: React.MutableRefObject<HTMLElement | null>;
}): JSX.Element => {
  const [menuAnchorEl, setMenuAnchorEl] = useState<null | HTMLElement>(null);
  const { enqueueSnackbar } = useSnackbar();
  const menuOpen = Boolean(menuAnchorEl);

  const handleClose = () => setMenuAnchorEl(null);
  return (
    <>
      <IconButton aria-label="Chart options" onClick={(e) => setMenuAnchorEl(e.currentTarget)}>
        <MoreVert />
      </IconButton>

      {/* <Backdrop open={menuOpen} onClick={handleClose} sx={{ zIndex: 1201 }}> */}
      <Menu
        anchorEl={menuAnchorEl}
        transformOrigin={{ horizontal: 'center', vertical: 'top' }}
        open={menuOpen}
        onClose={() => setMenuAnchorEl(null)}
        PaperProps={{ sx: { '.MuiList-root': { padding: 0 } } }}>
        <MenuItem
          onClick={() => {
            handleClose();
            elementRef !== null &&
              copyGraphToClipboard(elementRef as MutableRefObject<HTMLElement>)
                .then(() => {
                  enqueueSnackbar('Graph copied to clipboard successfully.', {
                    variant: 'success',
                    autoHideDuration: 3000,
                  });
                })
                .catch(() => {
                  enqueueSnackbar('Error while copying the graph.', {
                    variant: 'error',
                    autoHideDuration: 3000,
                  });
                });
          }}
          sx={{ padding: '10px 20px' }}>
          Copy
        </MenuItem>
      </Menu>
      {/* </Backdrop> */}
    </>
  );
};

export function PopoverValue({
  label,
  color,
  amount,
  percent,
}: {
  label?: string | null;
  color: string;
  amount?: string | number | null;
  percent?: string | number | null;
}): JSX.Element {
  return (
    <Grid container>
      <Grid item container alignItems={'center'} justifyContent={'center'}>
        <Grid item xs="auto">
          <Typography
            sx={{
              width: '11px',
              height: '11px',
              borderRadius: '50%',
              background: color,
              display: 'inline-block',
              mr: 1,
            }}></Typography>
        </Grid>
        <Grid item xs>
          <Typography sx={{ fontSize: 13, color: '#22242C', opacity: 0.6, mb: 0.5 }}>
            {label}
          </Typography>
        </Grid>
      </Grid>
      <Grid item container>
        <Grid item xs="auto">
          <Typography
            sx={{
              visibility: 'hidden',
              width: '11px',
              height: '11px',
              borderRadius: '50%',
              background: color,
              display: 'inline-block',
              mr: 1,
            }}></Typography>
        </Grid>
        <Grid item xs>
          <Typography
            sx={{
              fontSize: 13,
              color: '#22242C',
              fontWeight: 500,
            }}>
            {amount}
          </Typography>
        </Grid>
        <Grid item xs="auto">
          <Typography component="span" sx={{ fontSize: 12, fontWeight: 400, color: '#22242C' }}>
            {percent ? `${percent}%` : null}
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  );
}

export const AmountUnit = () => {
  const myState = useSelector((state: any) => state.valueConverter);
  const dispatch = useDispatch();

  const handleChange = (event: any) => {
    dispatch({ type: SET_VALUE, value: event.target.value });
  };

  return (
    <>
      <FormControl>
        <Select
          style={{ color: 'var(--title-color)', height: '1.7rem', width: '7rem' }}
          value={myState}
          onChange={handleChange}
          displayEmpty
          inputProps={{ 'aria-label': 'Without label' }}
          variant="standard"
          sx={{
            fontSize: 12,
            lineHeight: '16px',
            color: '#4E5056',
            fontWeight: 500,
            boxShadow: '1px 1px 3px rgba(0, 0, 0, 0.15)',
            borderRadius: '5px',
            pl: 1,
            background: ' #FFFFFF',
          }}>
          <MenuItem value={0} style={{ color: 'var(--title-color)' }}>
            Numbers
          </MenuItem>
          <MenuItem value={1} style={{ color: 'var(--title-color)' }}>
            Crores
          </MenuItem>
          <MenuItem value={2} style={{ color: 'var(--title-color)' }}>
            Lakhs
          </MenuItem>
        </Select>
      </FormControl>
    </>
  );
};

export function YearSelecter(props: any) {
  return (
    <div
      style={{
        cursor: 'pointer',
        flexGrow: 1,
        flexBasis: 0,
        paddingRight: !props.marginH ? props.marginH : 3,
        paddingLeft: !props.marginH ? props.marginH : 3,
        marginLeft: 2,
        marginRight: 2,
        // marginLeft: !!props.marginH ? props.marginH : 3,
        // marginRight: !!props.marginH ? props.marginH : 3,
        borderRadius: 5,
        paddingTop: !props.paddingV ? props.paddingV : 3,
        paddingBottom: !props.paddingV ? props.paddingV : 3,
        backgroundColor: props.isSelected ? '#337FC9' : 'transparent',
        border: '1px solid #163869',
      }}
      onClick={props.onPress}>
      <div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            color: props.isSelected ? '#FFFFFF' : '#5A7C82',
            alignItems: 'center',
          }}>
          {props.text}
        </div>
      </div>
    </div>
  );
}

export function TopHoldingButtons(props: any) {
  return (
    <div
      style={{
        display: 'flex',
        margin: 10,
        marginBottom: 15,
        borderRadius: 18,
        border:
          // props.selected === props.label
          '1px solid #00A4A4',
        backgroundColor: props.selected === props.label ? '#337FC9' : '#FFFFFF',
        color: props.selected === props.label ? '#FFFFFF' : '#337FC9',
        flexGrow: 1,
        flexBasis: 0,
        padding: 6,
        alignItems: 'center',
        justifyContent: 'space-between',
        cursor: 'pointer',
      }}
      onClick={props.onPress}>
      <div style={{ fontSize: 14, fontWeight: 500 }}>{props.label}</div>
      <div style={{ fontSize: 14, paddingTop: 5 }}>{props.percentage}%</div>
    </div>
  );
}

export function Disclaimer({
  text,
  containerStyles,
  textStyles,
}: {
  text: string | JSX.Element,
  containerStyles?: SxProps<Theme>,
  textStyles?: SxProps<Theme>,
}): JSX.Element {
  const theme = useTheme();
  return (
    <Box sx={{ ...containerStyles }}>
      <IconButton aria-label="Disclaimer information">
        <InfoIconOutlined />
      </IconButton>
      <Typography sx={{ ...textStyles, fontSize: { xs: '10px', sm: '12px', xl: '14px' } }}>{text}</Typography>
    </Box>
  )
}

registerPlugin(
  FilePondPluginImagePreview,
  FilePondPluginFileValidateType,
  FilePondPluginFileValidateSize
);

export interface FileUploadProps {
  label?: string;
  acceptedFileTypes: string[];
  maxFileSize: string;
  minFileSize?: string;
  maxFiles?: number;
  disabled?: boolean;
  onFileChange: (file: any) => void;
  error?: string;
  children?: React.ReactNode;
  setError?: (error: string) => void,
}

export function FileUpload({
  label,
  acceptedFileTypes,
  maxFileSize,
  minFileSize,
  maxFiles = 1,
  disabled = false,
  onFileChange,
  error,
  children,
  setError,
}: FileUploadProps): JSX.Element {
  const [files, setFiles] = useState<any>([]);

  useEffect(() => {
    if (files.length === 0) {
      onFileChange(null);
    }
  }, [files, onFileChange]);

  // console.log('files', files);

  return (
    <Box>
      {label && (
        <Typography variant="subtitle_500" mb={1}>
          {label}
        </Typography>
      )}

      <Grid container
        sx={(theme: Theme) => ({
          background: theme.palette.common.white,
          border: `0.5px solid ${theme.palette.text.secondary}80`,
          p: 1,
          borderRadius: "10px",
          rowGap: "10px",
          '.filepond--root': {
            fontFamily: `${theme.typography.fontFamily}`,
            mb: 0,
          },
          '.filepond--panel-root': {
            background: theme.palette.common.white,
          },
          '.filepond--credits': { display: 'none' },
          '.filepond--label-action': {
            color: `${theme.palette.primary[500]}`,
            fontFamily: `${theme.typography.fontFamily}`,
            letterSpacing: '0.2px',
            cursor: 'pointer',
            fontSize: '14px',
            fontWeight: '500',
            textDecoration: 'none'
          },
          '.filepond--label-format': {
            color: `${theme.palette.text.secondary}`,
            fontWeight: '400',
            paddingLeft: '5px',
            textDecoration: 'none'
          },
          '.filepond-subheading': {
            fontSize: '14px',
            fontWeight: '400',
            color: `${theme.palette.text.secondary}`,

          },
          '.filepond--drop-label': {
            cursor: disabled ? 'not-allowed' : 'pointer',
            pointerEvents: 'all',

          },
          '.filepond--file': {
            color: '#000',
            flexWrap: 'wrap',
            fontWeight: 500,
          },
          '.filepond--file-wrapper': {
            backgroundColor: theme.palette.primary[100],
          },
          '.delete-icon-container': {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "primary.50",
            borderRadius: "50%",
            padding: "5px",
            cursor: "pointer"
          },
          '.filepond--image-preview-overlay-success': {
            color: theme.palette.primary[100],
          },
          '.filepond--image-preview-wrapper': {
            backgroundColor: theme.palette.primary[100],
          },
          '.filepond--file-info-main': {
            color: theme.palette.common.black,
            opacity: 1
          },
          '.filepond--file-info-sub': {
            color: theme.palette.common.black,
            opacity: 1
          },
        })}
        item
        xs={12}
      >
        <Grid item xs={12}>
          <FilePond
            files={files}
            onupdatefiles={(fileItems) => {
              setFiles?.(fileItems);
              const file = fileItems[0]?.file as File | null;
              onFileChange(file);
            }}
            onaddfile={(e) => {
              if (e) {
                setError?.('Please reupload the file.');
              }
            }}
            allowMultiple={false}
            maxFiles={maxFiles}
            disabled={disabled}
            acceptedFileTypes={acceptedFileTypes}
            instantUpload={false}
            allowRevert
            imagePreviewHeight={100}
            styleItemPanelAspectRatio="0.2"
            allowDrop
            allowBrowse
            credits={false}
            allowPaste={false}
            minFileSize={minFileSize}
            maxFileSize={maxFileSize}
            labelIdle={`
              <div style="display:flex; align-items:center; gap:12px;">
                <img src="/images/filePondIcon.svg" alt="" style="height:30px; width:30px;" />
                <div>
                  <span class="filepond--label-action" tabindex="0" role="button" aria-label="Click to upload file">
                    Click to Upload
                    <span class="filepond--label-format">
                     (${acceptedFileTypes?.map((f) => f.split('/')[1]).join(', ')})
                    </span>
                  </span>
                  <div class="filepond-subheading">
                    ${minFileSize ? `(Min File Size: ${minFileSize}), ` : ''}(Max File Size: ${maxFileSize})
                  </div>
                </div>
              </div>
            `}
            labelFileTypeNotAllowed={'Invalid file type'}
            labelMaxFileSize={`Max file size is ${maxFileSize}`}
            labelMinFileSize={`Min file size is ${minFileSize}`}
            fileValidateTypeLabelExpectedTypesMap={{
              'image/jpeg': '.jpeg',
              'image/jpg': '.jpg',
              'image/png': '.png',
              'application/pdf': '.pdf',
            }}
            iconRemove={`
              <div class="delete-icon-container">
                <img src="/images/delete-blue.svg"
              </div>
            `}
          />
        </Grid>
        {children}
      </Grid >

      {
        `${error ?? ''}`?.length > 0 && (
          <Typography color="error" variant="body_400" mt={1}>
            {error}
          </Typography>
        )
      }
    </Box >
  );
}
